<template>
    <div class="container-fluid add-monitor-container">
        <div class="row">
            <div class="col-md-12">
                <form action="" @submit.prevent="onSubmit()">
                    <!-- Step 1: Monitor Type and Friendly Name -->
                    <div class="form-step-one">
                    <b-row>
                            <b-col md="6">
                            <div class="form-group">
                            <label class="form-label">
                                Monitor Type <span class="required">*</span>
                            </label>
                            <div class="custom-select-wrapper" :class="{ 'has-validation': isTypeSelected }">
                                <img src="@/assets/icons/monitor-selector.svg" alt="Monitor" class="select-icon" />
                                <b-form-select 
                                    name="type" 
                                    v-model="monitor_input.type" 
                                    :options="monitor_type_opt" 
                                    :state="isTypeSelected ? !invalid_type_message : null"
                                    @change="validateType"
                                    class="custom-form-select"
                                    :disabled="edit_monitor"
                                    required>
                                </b-form-select>
                                <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <b-form-invalid-feedback :state="validate_type">
                                Select Monitor type
                            </b-form-invalid-feedback>
                            </div>
                        </b-col>
                            <b-col md="6">
                            <div class="form-group">
                            <label class="form-label">
                                Friendly Name <span class="required">*</span>
                            </label>
                            <div class="custom-input-wrapper" :class="{ 'has-validation': isNameEntered }">
                                <b-form-input 
                                    type="text" 
                                    name="mname" 
                                    v-model="monitor_input.name" 
                                    :state="null"  
                                    @input="validateName" 
                                    maxlength="50" 
                                    placeholder="Enter Name"
                                    class="custom-form-input"
                                    required>
                                </b-form-input>
                                <span v-if="isNameEntered" class="validation-icon">
                                    <svg v-if="!invalid_fname_message" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                                        <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                                        <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <b-form-invalid-feedback v-if="isNameEntered">
                                {{ invalid_fname_message }}
                            </b-form-invalid-feedback>
                            </div>
                        </b-col>
                    </b-row>
                   </div>

                    <!-- Step 2: Additional Fields - Only show when type and name are filled -->
                    <div v-if="showAdditionalFields" class="form-step-two">
                        <!-- URL and Alert Frequency -->
                    <b-row>
                            <b-col md="6" v-if="monitor_input.type != 5">
                                <div class="form-group">
                                    <label class="form-label">
                                        {{ inputPlaceholder }} <span class="required">*</span>
                                    </label>
                                    <div class="custom-input-wrapper" :class="{ 'has-validation': isUrlEntered }">
                                        <b-form-input 
                                            type="text" 
                                            v-model="monitor_input.url" 
                                            maxlength="500" 
                                            :state="null" 
                                            @input="validate_url" 
                                            :placeholder="inputPlaceholder"
                                            class="custom-form-input"
                                            required>
                                        </b-form-input>
                                        <span v-if="isUrlEntered" class="validation-icon">
                                            <svg v-if="!invalid_url_message" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                                                <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                                                <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                    </div>
                                    <b-form-invalid-feedback v-if="isUrlEntered">
                                        {{ invalid_url_message }}
                                    </b-form-invalid-feedback>
                                </div>
                        </b-col>
                            <b-col :md="monitor_input.type == 5 ? 12 : 6">
                                <div class="form-group">
                                    <label class="form-label">Alert Frequency</label>
                                    <div class="custom-select-wrapper">
                                        <b-form-select 
                                            name="type" 
                                            v-model="monitor_input.downAlertFreqType" 
                                            :options="alert_freq_opt"
                                            class="custom-form-select"
                                            required>
                                        </b-form-select>
                                        <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>
                                </b-col>
                        </b-row>

                        <!-- Keyword Monitor Fields -->
                        <div v-if="monitor_input.type == 2">
                            <b-row>
                                <b-col md="12">
                                    <div class="form-group">
                                        <label class="form-label">
                                            Keyword <span class="form-label-info">(The keyword must be present in HTML source)</span> <span class="required">*</span>
                                        </label>
                                        <div class="custom-input-wrapper" :class="{ 'has-validation': isKeywordEntered }">
                                            <b-form-input 
                                                type="text" 
                                                v-model="monitor_input.keyword" 
                                                maxlength="1000" 
                                                :state="null" 
                                                @input="validate_keyword" 
                                                placeholder="Enter keyword"
                                                class="custom-form-input"
                                                required>
                                            </b-form-input>
                                            <span v-if="isKeywordEntered" class="validation-icon">
                                                <svg v-if="!invalid_keyword_message" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                                                    <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                                                    <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </div>
                                        <b-form-invalid-feedback v-if="isKeywordEntered">
                                            {{ invalid_keyword_message }}
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-col>
                            </b-row>
                            
                            <b-row>
                                <b-col md="12">
                                    <div class="form-group">
                                        <label class="form-label">Alert When</label>
                                        <div class="alert-when-container">
                                            <div class="alert-when-option">
                                                <label class="custom-checkbox">
                                                    <input 
                                                        type="checkbox" 
                                                        :checked="monitor_input.alertWhen === 2"
                                                        @change="monitor_input.alertWhen = monitor_input.alertWhen === 2 ? 1 : 2"
                                                    />
                                                    <span class="checkbox-checkmark"></span>
                                                    <span class="checkbox-label">Keyword Not Exists</span>
                                                </label>
                                            </div>
                                            <div class="alert-when-option">
                                                <label class="custom-checkbox">
                                                    <input 
                                                        type="checkbox" 
                                                        :checked="monitor_input.alertWhen === 1"
                                                        @change="monitor_input.alertWhen = monitor_input.alertWhen === 1 ? 2 : 1"
                                                    />
                                                    <span class="checkbox-checkmark"></span>
                                                    <span class="checkbox-label">Keyword Exists</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            
                            <b-row>
                                <b-col md="12">
                                    <div class="form-group">
                                        <div class="keyword-case-container">
                                            <span class="case-label">Case - Insensitive</span>
                                            <label class="toggle-switch">
                                                <input type="checkbox" v-model="monitor_input.case_sensitive" />
                                                <span class="toggle-slider"></span>
                                            </label>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        
                        <!-- Port Monitor Fields -->
                        <div v-if="monitor_input.type == 4">
                            <b-row>
                                <b-col md="6">
                                    <div class="form-group">
                                        <label class="form-label">
                                            Port <span class="required">*</span>
                                        </label>
                                        <div class="custom-select-wrapper" :class="{ 'has-validation': isPortSelected }">
                                            <b-form-select 
                                                v-model="monitor_input.port" 
                                                :options="port_opt" 
                                                :state="isPortSelected ? !invalid_port_message : null" 
                                                @change="validate_port"
                                                class="custom-form-select"
                                                required>
                                            </b-form-select>
                                            <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                        <b-form-invalid-feedback v-if="isPortSelected">
                                            {{ invalid_port_message }}
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="form-group">
                                        <label class="form-label">
                                            Custom Port <span class="required">*</span>
                                        </label>
                                        <div class="custom-input-wrapper" :class="{ 'has-validation': isCustomPortEntered && !show_custom_port }">
                                            <b-form-input 
                                                type="number" 
                                                v-model="monitor_input.custom_port" 
                                                :state="null" 
                                                placeholder="Enter custom port" 
                                                :disabled="show_custom_port"
                                                class="custom-form-input"
                                                @input="validateCustomPort"
                                                min="1"
                                                max="65535"
                                                required>
                                            </b-form-input>
                                            <span v-if="isCustomPortEntered && !show_custom_port" class="validation-icon">
                                                <svg v-if="validatePort" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                                                    <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                                                    <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </div>
                                        <b-form-invalid-feedback v-if="!show_custom_port && monitor_input.port == 0" :state="validatePort">
                                            Port must be between 1 and 65535
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <!-- Alert Contacts - Full Width -->
                        <b-row>
                            <b-col md="12">
                                <div class="form-group">
                                    <label class="form-label">Select Alert Contacts To Notify </label>
                                    <div class="custom-select-wrapper alert-select" @click="toggleAlertDropdown">
                                        <span class="select-placeholder">{{ alertSelectText }}</span>
                                        <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        
                                        <!-- Alert Dropdown -->
                                        <div v-if="showAlertDropdown" class="alert-dropdown" @click.stop>
                                            <div class="alert-search">
                                                <input 
                                                    type="text" 
                                                    v-model="alertSearchQuery" 
                                                    placeholder="Search alert contacts..."
                                                    class="alert-search-input"
                                                    @click.stop
                                                />
                                            </div>
                                            <div class="alert-options">
                                                <div 
                                                    v-for="alert in filteredAlertsList" 
                                                    :key="alert.value"
                                                    class="alert-option"
                                                    :class="{ 'selected': isAlertSelected(alert) }"
                                                    @click.stop="toggleAlert(alert)"
                                                >
                                                    <input 
                                                        type="checkbox" 
                                                        :checked="isAlertSelected(alert)"
                                                        class="alert-checkbox"
                                                    />
                                                    <span>{{ alert.text }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- Selected Alert Contacts Display -->
                                    <div v-if="alertContacts && alertContacts.length > 0" class="selected-alerts-section">
                                        <div class="selected-alerts-tags">
                                            <span 
                                                v-for="alert in alertContacts" 
                                                :key="alert.value"
                                                class="alert-tag"
                                            >
                                                <span class="alert-tag-dot"></span>
                                                {{ alert.text }}
                                                <svg @click="removeAlertContact(alert)" class="tag-remove" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <!-- Monitoring Interval and Monitor Timeout -->
                    <b-row>
                            <b-col md="6">
                                <div class="form-group">
                                    <label class="form-label">Monitoring Interval</label>
                                    <div class="new-interval-container">
                                        <div class="interval-controls">
                                            <button type="button" class="interval-control-btn" @click="decrementInterval" :disabled="intervalIndex <= 0">
                                                <span>−</span>
                                            </button>
                                            <span class="interval-value">{{ intervalDisplayValue }}</span>
                                            <button type="button" class="interval-control-btn" @click="incrementInterval" :disabled="intervalIndex >= currentIntervalData.length - 1">
                                                <span>+</span>
                                            </button>
                                        </div>
                                        <span class="interval-unit-text">{{ intervalUnit === 'minutes' ? 'Every Minutes' : 'Every Hours' }}</span>
                                    </div>
                            </div>
                        </b-col>
                            <b-col md="6"  v-if="monitor_input.type != 3 && monitor_input.type != 5">
                                <div class="form-group">
                                    <label class="form-label">Monitor Timeout</label>
                                    <div class="new-interval-container">
                                        <div class="interval-controls">
                                            <button 
                                                type="button" 
                                                class="interval-control-btn" 
                                                @click="decrementTimeout"
                                                :disabled="monitor_input.timeout <= 1"
                                            >
                                                <span>−</span>
                                            </button>
                                            <span class="interval-value">{{ timeoutDisplayValue }}</span>
                                            <button 
                                                type="button" 
                                                class="interval-control-btn" 
                                                @click="incrementTimeout"
                                                :disabled="monitor_input.timeout >= 60"
                                            >
                                                <span>+</span>
                                            </button>
                                        </div>
                                        <span class="interval-unit-text">Every Seconds</span>
                                    </div>
                    </div>
                        </b-col>
                        </b-row>

                        <!-- Grace Timeout and Device Type -->
                        <b-row>
                            <b-col md="6" v-if="monitor_input.type == 5">
                            <div class="form-group">
                                <label class="form-label">Grace Timeout</label>
                                <div class="new-interval-container">
                                    <div class="interval-controls">
                                        <button 
                                            type="button" 
                                            class="interval-control-btn" 
                                            @click="decrementGraceTimeout"
                                            :disabled="graceTimeoutIndex <= 0"
                                        >
                                            <span>−</span>
                                        </button>
                                        <span class="interval-value">{{ monitor_input.grace_interval }}</span>
                                        <button 
                                            type="button" 
                                            class="interval-control-btn" 
                                            @click="incrementGraceTimeout"
                                            :disabled="graceTimeoutIndex >= grace_timeout_datas.length - 1"
                                        >
                                            <span>+</span>
                                        </button>
                                    </div>
                                    <span class="interval-unit-text"> Every Seconds</span>
                                </div>
                            </div>
                        </b-col>
                            <b-col md="6" v-if="monitor_input.type == 7">
                                <div class="form-group">
                                    <label class="form-label">
                                        Device Type <span class="required">*</span>
                                    </label>
                                    <div class="custom-select-wrapper" :class="{ 'has-validation': isDeviceTypeSelected }">
                                        <img src="@/assets/icons/mobile-device.svg" alt="Device" class="select-icon" />
                                        <b-form-select 
                                            name="devicetype" 
                                            v-model="monitor_input.devicetype" 
                                            :options="device_type_opt" 
                                            :state="isDeviceTypeSelected ? !invalid_devicetype_message : null" 
                                            @change="validate_deviceType"
                                            class="custom-form-select"
                                            required>
                                        </b-form-select>
                                        <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                            <b-form-invalid-feedback v-if="isDeviceTypeSelected">
                                {{ invalid_devicetype_message }}
                            </b-form-invalid-feedback>
                                </div>
                        </b-col>
                    </b-row>

                        <!-- SSL Options -->
                        <div v-if="monitor_input.type != 3 && monitor_input.type != 4 && monitor_input.type != 5 && monitor_input.type != 6 && monitor_input.type != 7 && show_SSL">
                            <b-row>
                                <b-col md="12">
                                    <div class="form-group">
                                        <label class="form-label">SSL Monitoring</label>
                                        <div class="ssl-options-container">
                                            <div class="ssl-option">
                                                <label class="custom-checkbox">
                                                    <input type="checkbox" v-model="monitor_input.ssl_error" />
                                                    <span class="checkbox-checkmark"></span>
                                                    <span class="checkbox-label">Monitor SSL errors</span>
                                                </label>
                                            </div>
                                            <div class="ssl-option">
                                                <div>
                                                    <label class="custom-checkbox">
                                                        <input type="checkbox" v-model="monitor_input.ssl_expiry_reminder" />
                                                        <span class="checkbox-checkmark"></span>
                                                        <span class="checkbox-label">Enable SSL expiry reminders</span>
                                                    </label>
                                                    <p class="ssl-hint">Monitor URL needs to start with "https" for SSL monitoring to work.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>

                        <!-- HTTP Method -->
                        <div v-if="monitor_input.type != 3 && monitor_input.type != 4 && monitor_input.type != 5 && monitor_input.type != 6 && monitor_input.type != 7">
                            <b-row>
                                <b-col md="12">
                            <div class="form-group">
                                <label class="form-label">HTTP Method</label>
                                <div class="http-method-buttons">
                                    <span :class="monitor_input.http_method == 'HEAD' ? 'mul-select-btn-active': 'mul-select-btn-inactive'"  
                                        @click="monitor_input.http_method = 'HEAD'">HEAD</span>
                                    <span :class="monitor_input.http_method == 'GET' ? 'mul-select-btn-active': 'mul-select-btn-inactive'" 
                                        @click="monitor_input.http_method = 'GET'">GET</span>
                                    <span :class="monitor_input.http_method == 'POST' ? 'mul-select-btn-active': 'mul-select-btn-inactive'" 
                                        @click="monitor_input.http_method = 'POST'">POST</span>
                                    <span :class="monitor_input.http_method == 'PUT' ? 'mul-select-btn-active': 'mul-select-btn-inactive'" 
                                        @click="monitor_input.http_method = 'PUT'">PUT</span>
                                    <span :class="monitor_input.http_method == 'PATCH' ? 'mul-select-btn-active': 'mul-select-btn-inactive'" 
                                        @click="monitor_input.http_method = 'PATCH'">PATCH</span>
                                    <span :class="monitor_input.http_method == 'DELETE' ? 'mul-select-btn-active': 'mul-select-btn-inactive'" 
                                        @click="monitor_input.http_method = 'DELETE'">DELETE</span>
                                    <span :class="monitor_input.http_method == 'OPTIONS' ? 'mul-select-btn-active': 'mul-select-btn-inactive'" 
                                        @click="monitor_input.http_method = 'OPTIONS'">OPTIONS</span>
                                </div>
                            </div>
                                        </b-col> 
                                    </b-row>

                            <!-- POST Data section -->
                            <b-row v-if="monitor_input.http_method == 'POST' || monitor_input.http_method == 'PUT' || monitor_input.http_method == 'PATCH' || monitor_input.http_method == 'DELETE' || monitor_input.http_method == 'OPTIONS'">
                                <b-col md="12">
                                <div class="post-data-section">
                                    <div class="info-text mb-3">
                                        HEAD is suggested (as it is lighter) if there is no specific reason to use {{ monitor_input.http_method }}.
                                    </div>
                                    
                                    <div class="mb-3">
                                        <span :class="post_data_type == 1 ? 'mul-select-btn-active': 'mul-select-btn-inactive'" 
                                            @click="post_data_type = 1">ADD key/value</span>
                                        <span :class="post_data_type == 2 ? 'mul-select-btn-active': 'mul-select-btn-inactive'" 
                                            @click="post_data_type = 2">Add raw data</span>
                                    </div>

                                    <div v-show="post_data_type == 1">
                                       <div class="post-key-value-container">
                                            <label class="form-label">Key / Value</label>
                                            <div v-if="post_key_val_data.length === 0" class="add-header-button" @click="post_key_val_data.push({value: '',key:''})">
                                                <img src="@/assets/icons/add-field-icon.svg" alt="Add" width="24" height="24" />
                                                <span>Add Key and Value</span>
                                            </div>
                                            <div v-else class="custom-headers-container">
                                                <div v-for="(v,i) in post_key_val_data" :key="i" class="header-row">
                                                    <div class="header-inputs">
                                                        <div class="header-input-group">
                                                            <label class="header-label">Key</label>
                                                            <div class="header-input-wrapper">
                                                                <b-form-input 
                                                                    type="text" 
                                                                    placeholder="key" 
                                                                    v-model="v.key" 
                                                                    maxlength="2500"
                                                                    class="header-input"
                                                                ></b-form-input>
                                                            </div>
                                                        </div>
                                                        <div class="header-input-group">
                                                            <label class="header-label">Value</label>
                                                            <div class="header-input-wrapper">
                                                                <b-form-input 
                                                                    type="text" 
                                                                    placeholder="value" 
                                                                    v-model="v.value" 
                                                                    maxlength="2500"
                                                                    class="header-input"
                                                                ></b-form-input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="header-actions">
                                                        <button 
                                                            type="button"
                                                            class="header-delete-btn" 
                                                            @click="post_key_val_data.splice(i,1)"
                                                        >
                                                            <img src="@/assets/icons/delete-field-icon.svg" alt="Delete" width="24" height="24" />
                                                        </button>
                                                        <button 
                                                            type="button"
                                                            class="header-add-btn" 
                                                            @click="post_key_val_data.push({value: '',key:''})"
                                                        >
                                                            <img src="@/assets/icons/add-field-icon.svg" alt="Add" width="24" height="24" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                       </div>
                                    </div>
                                    
                                    <div v-show="post_data_type == 2">
                                       <div class="post-raw-data-container">
                                            <label class="form-label">Raw Data</label>
                                            <div class="raw-data-wrapper">
                                                <textarea 
                                                    class="raw-data-input" 
                                                    name="row_data" 
                                                    id="row_data" 
                                                    rows="4" 
                                                    v-model="post_row_data" 
                                                    placeholder='{"Key": "Value"}'>
                                                </textarea>
                                            </div>
                                       </div>
                                    </div>

                                    <div class="mt-3">
                                        <input class="checkbox_animated" name="postContentType" type="checkbox" v-model="postContentType">
                                        <span class="ml-2 info_txt">
                                            Send as JSON (application/json). If not selected, the data will be sent as a standard POST (application/x-www-form-urlencoded).
                                        </span> 
                                    </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>

                        <!-- Advanced Settings -->
                        <div v-if="monitor_input.type != 3 && monitor_input.type != 4 && monitor_input.type != 5 && monitor_input.type != 6 && monitor_input.type != 7" class="advanced-settings-section">
                            <div class="advanced-settings-container">
                                <div class="advanced-settings-header">
                                    <span class="advanced-settings-label">Advanced Settings (optional)</span>
                                    <label class="toggle-switch">
                                        <input type="checkbox" v-model="showAdvancedSettings" />
                                        <span class="toggle-slider"></span>
                                    </label>
                                </div>
                            
                     <div v-if="showAdvancedSettings" class="advanced-settings-content">
                                <!-- Authentication Settings -->
                                <div class="accordion-item">
                                    <div class="accordion-header" @click="toggleAccordion('auth')">
                                        <span class="accordion-label">Authentication Setting</span>
                                        <svg class="accordion-arrow" :class="{ 'rotated': accordionStates.auth }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div v-if="accordionStates.auth" class="accordion-content">
                                        <div class="auth-inputs-row">
                                            <div class="auth-input-group">
                                                <label class="auth-label">User Name</label>
                                                <div class="auth-input-wrapper" :class="{ 'is-invalid': isUsernameEntered && invalid_username_message }">
                                                    <b-form-input 
                                                        class="auth-input"
                                                        type="text" 
                                                        v-model="monitor_input.auth_username" 
                                                        maxlength="50" 
                                                        @input="validateUsername" 
                                                        placeholder="Enter username">
                                                    </b-form-input>
                                                </div>
                                                <b-form-invalid-feedback v-if="isUsernameEntered && invalid_username_message" :state="false">
                                                    {{ invalid_username_message }}
                                                </b-form-invalid-feedback>
                                            </div>
                                            <div class="auth-input-group">
                                                <label class="auth-label">Authentication Type</label>
                                                <div class="auth-type-dropdown">
                                                    <b-form-select 
                                                        class="auth-select"
                                                        :class="{ 'placeholder-selected': !monitor_input.auth_type }"
                                                        v-model="monitor_input.auth_type"
                                                        :options="authTypeOptions">
                                                    </b-form-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="auth-password-group">
                                            <label class="auth-label">Password <span class="text-danger">*</span></label>
                                            <div class="password-input-wrapper">
                                                <svg class="password-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12 14.5V16.5" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M11.994 14H12.003" stroke="#1C274C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <b-form-input 
                                                    class="auth-input with-icons"
                                                    :type="showPassword ? 'text' : 'password'" 
                                                    v-model="monitor_input.auth_password" 
                                                    maxlength="25" 
                                                    :state="validate_passwordlimit" 
                                                    placeholder="Enter password">
                                                </b-form-input>
                                                <button type="button" class="password-toggle" @click="showPassword = !showPassword">
                                                    <svg v-if="!showPassword" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M12 15C13.657 15 15 13.657 15 12C15 10.343 13.657 9 12 9C10.343 9 9 10.343 9 12C9 13.657 10.343 15 12 15Z" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4 4L20 20" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M16.5 16.679C15.063 17.511 13.385 18 11.607 18C7.607 18 4.607 15.5 2.607 11C3.381 9.501 4.438 8.174 5.704 7.092M9.879 6.121C10.42 5.884 10.999 5.757 11.606 5.757C15.606 5.757 18.607 8.257 20.607 12.757C20.107 13.757 19.507 14.657 18.807 15.457" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M11 9C12.656 9 14 10.343 14 12C14 12.33 13.935 12.645 13.817 12.933M9.879 9.879L13.121 13.121" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Custom HTTP Statuses -->
                                <div v-if="monitor_input.type == 1" class="accordion-item">
                                    <div class="accordion-header" @click="toggleAccordion('httpStatus')">
                                        <span class="accordion-label">Custom HTTP Statuses</span>
                                        <svg class="accordion-arrow" :class="{ 'rotated': accordionStates.httpStatus }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div v-if="accordionStates.httpStatus" class="accordion-content">
                                        <b-row>
                                            <b-col>
                                                <p class="info_txt">You can drag and drop to modify <strong><span class="text-success">Up</span>/<span class="text-danger">Down</span></strong> statuses.</p>
                                            </b-col>
                                        </b-row>
                                        <div class="drag-drop-vue" style="cursor:pointer;" title="click and drag">
                                            <div
                                            class="pull-left text-center"
                                            v-dragula="monitor_input.up_status"
                                            service="my-third"
                                            drake="b"
                                            >
                                            <!-- <span style="color:white;">Up Status Code</span> -->
                                            <div class="drag-btn-up" v-for="text in monitor_input.up_status" :key="text">
                                                <!-- <span class="dlt-status-btn" @click="CheckStatus(text,'up')" title="delete status"> X </span> -->
                                                <span class="p-2" @click="MoveStatus('right',text)">{{ text }}</span>
                                            </div>
                                            </div>
                                            <div
                                            class="pull-right text-center"
                                            v-dragula="monitor_input.down_status"
                                            service="my-third"
                                            drake="b"
                                            >
                                            <!-- <span style="color:white;">Down Status Code</span> -->
                                            <div class="drag-btn-down" v-for="text in monitor_input.down_status" :key="text">
                                                <!-- <span class="dlt-status-btn" @click="CheckStatus(text,'down')" title="delete status"> X </span> -->
                                                <span class="p-2" @click="MoveStatus('left',text)">{{ text }}</span>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Custom Headers -->
                                <div class="accordion-item">
                                    <div class="accordion-header" @click="toggleAccordion('headers')">
                                        <span class="accordion-label">Custom Header</span>
                                        <svg class="accordion-arrow" :class="{ 'rotated': accordionStates.headers }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div v-if="accordionStates.headers" class="accordion-content">
                                        <p class="header-instruction">for example pass custom header parameters: <span class="header-key-text">key</span> and <span class="header-value-text">value</span></p>
                                        
                                        <!-- Add Header Button - shown when no headers exist -->
                                        <div v-if="custom_headers.length === 0" class="add-header-button" @click="custom_headers.push({value: '',key:''})">
                                            <img src="@/assets/icons/add-field-icon.svg" alt="Add" width="24" height="24">
                                            <span>Add Key and Value</span>
                                        </div>
                                        
                                        <!-- Header Fields -->
                                        <div class="custom-headers-container">
                                            <div v-for="(v,i) in custom_headers" :key="i" class="header-row">
                                                <div class="header-inputs">
                                                    <div class="header-input-group" v-if="i === 0">
                                                        <label class="header-label">Key</label>
                                                        <div class="header-input-wrapper">
                                                            <b-form-input 
                                                                class="header-input"
                                                                type="text" 
                                                                placeholder="Enter Key" 
                                                                v-model="v.key" 
                                                                @blur="validateHeaderKey(i)">
                                                            </b-form-input>
                                                        </div>
                                                        <span v-show="v.keyError" class="text-danger small">{{ v.keyError }}</span>
                                                    </div>
                                                    <div class="header-input-group" v-else>
                                                        <div class="header-input-wrapper">
                                                            <b-form-input 
                                                                class="header-input"
                                                                type="text" 
                                                                placeholder="Enter Key" 
                                                                v-model="v.key" 
                                                                @blur="validateHeaderKey(i)">
                                                            </b-form-input>
                                                        </div>
                                                        <span v-show="v.keyError" class="text-danger small">{{ v.keyError }}</span>
                                                    </div>
                                                    
                                                    <div class="header-input-group" v-if="i === 0">
                                                        <label class="header-label">Value</label>
                                                        <div class="header-input-wrapper">
                                                            <b-form-input 
                                                                class="header-input"
                                                                type="text" 
                                                                placeholder="Enter Value" 
                                                                v-model="v.value" 
                                                                @blur="validateHeaderValue(i)">
                                                            </b-form-input>
                                                        </div>
                                                        <span v-show="v.valueError" class="text-danger small">{{ v.valueError }}</span>
                                                    </div>
                                                    <div class="header-input-group" v-else>
                                                        <div class="header-input-wrapper">
                                                            <b-form-input 
                                                                class="header-input"
                                                                type="text" 
                                                                placeholder="Enter Value" 
                                                                v-model="v.value" 
                                                                @blur="validateHeaderValue(i)">
                                                            </b-form-input>
                                                        </div>
                                                        <span v-show="v.valueError" class="text-danger small">{{ v.valueError }}</span>
                                                    </div>
                                                </div>
                                                
                                                <div class="header-actions">
                                                    <button type="button" class="header-delete-btn" @click="deltHeader(i)">
                                                        <img src="@/assets/icons/delete-field-icon.svg" alt="Delete" width="24" height="24">
                                                    </button>
                                                    <button type="button" class="header-add-btn" @click="Clone()">
                                                        <img src="@/assets/icons/add-field-icon.svg" alt="Add" width="24" height="24">
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Proxy URL -->
                                <div class="accordion-item">
                                    <div class="accordion-header" @click="toggleAccordion('proxy')">
                                        <span class="accordion-label">Custom Proxy</span>
                                        <svg class="accordion-arrow" :class="{ 'rotated': accordionStates.proxy }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div v-if="accordionStates.proxy" class="accordion-content">
                                        <div class="proxy-input-wrapper" :class="{ 'has-validation': isProxyUrlEntered }">
                                            <b-form-input 
                                                class="proxy-input"
                                                type="text" 
                                                v-model="monitor_input.proxyUrl" 
                                                @input="validate_proxy_url"
                                                placeholder="Enter Proxy URL or IP">
                                            </b-form-input>
                                            <span v-if="isProxyUrlEntered" class="validation-icon">
                                                <svg v-if="!invalid_proxy_url_message" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                                                    <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                                                    <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </div>
                                        <b-form-invalid-feedback v-if="isProxyUrlEntered && invalid_proxy_url_message" :state="false">
                                            {{ invalid_proxy_url_message }}
                                        </b-form-invalid-feedback>
                                    </div>
                                </div>
                            </div>
                            </div>
                            </div>

                        <!-- Maintenance Windows -->
                        <div class="maintenance-window-wrapper">
                            <div class="maintenance-window-container">
                                <span class="maintenance-window-label">Maintenance Window</span>
                                <label class="toggle-switch">
                                    <input type="checkbox" v-model="showMaintenanceWindows">
                                    <span class="toggle-slider"></span>
                                </label>
                            </div>
                            
                            <div v-if="showMaintenanceWindows" class="maintenance-dropdown-inner">
                                <div class="custom-select-wrapper maintenance-select" @click="toggleMaintenanceDropdown">
                                    <span class="select-placeholder">{{ maintenanceSelectText }}</span>
                                    <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    
                                    <!-- Maintenance Dropdown -->
                                    <div v-if="showMaintenanceDropdown" class="maintenance-dropdown" @click.stop>
                                        <div class="maintenance-search">
                                            <input 
                                                type="text" 
                                                v-model="maintenanceSearchQuery" 
                                                placeholder="Search maintenance windows..."
                                                class="maintenance-search-input"
                                                @click.stop
                                            />
                                        </div>
                                        <div class="maintenance-options">
                                            <div 
                                                v-for="maintenance in filteredMaintenanceList" 
                                                :key="maintenance.value"
                                                class="maintenance-option"
                                                :class="{ 'selected': isMaintenanceSelected(maintenance) }"
                                                @click.stop="toggleMaintenance(maintenance)"
                                            >
                                                <input 
                                                    type="checkbox" 
                                                    :checked="isMaintenanceSelected(maintenance)"
                                                    class="maintenance-checkbox"
                                                />
                                                <span>{{ maintenance.text }}</span>
                                                <span v-if="maintenance.badge" class="badge badge-maintenance">{{ maintenance.badge }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Selected Maintenance Windows Display -->
                                <div v-if="selectedMaintenanceWindows && selectedMaintenanceWindows.length > 0" class="selected-maintenance-section">
                                    <div class="selected-maintenance-tags">
                                        <span 
                                            v-for="maintenance in selectedMaintenanceWindows" 
                                            :key="maintenance.value"
                                            class="maintenance-tag"
                                        >
                                            <span class="maintenance-tag-dot"></span>
                                            {{ maintenance.text }}
                                            <svg @click="removeMaintenanceWindow(maintenance)" class="tag-remove" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Form Actions -->
                    <div class="form-actions mt-4" :class="{ 'form-actions-dual': showAdditionalFields && !edit_monitor }">
                        <button 
                            type="submit" 
                            class="btn-primary-custom" 
                            :disabled="!canSubmit || onLoading"
                            :class="{ 'disabled': !canSubmit || onLoading }">
                            {{ showAdditionalFields ? (edit_monitor ? 'Edit Monitor' : 'Save & Close') : 'Create Now' }}
                        </button>
                        <button 
                            type="button"
                            :class="[canSubmit && !onLoading ? 'btn-primary-custom' : 'btn-secondary-custom', { 'disabled': !canSubmit || onLoading }]"
                            v-if="showAdditionalFields && !edit_monitor" 
                            @click="addMoreMonitor()"
                            :disabled="!canSubmit || onLoading">
                            Add Another
                        </button>
                </div>
        </form>
            </div>
        </div>
    </div>
</template>

<script>
 import VueSlideBar from "vue-slide-bar";
 import MonitorController from "../../services/monitorController"
 import { hertbeatUrl } from "../../services/config";
 import MaintenanceController from "../../services/maintenanceController";
 import Multiselect from 'vue-multiselect';
 import VueSlider from 'vue-slider-component';
import moment from 'moment';
import { monitorEvents } from '@/plugins/posthog-events';

 export default {
    components: { VueSlideBar, Multiselect, VueSlider },
    props: { add_monitor_modal: Boolean, edit_monitor: Boolean, monitor_data: Object },
    data() {
        return {
            show_SSL: true,
            authKey: 1,
            sliderKey: 0,
            showPassword: false,
            authTypeOptions: [
                { value: null, text: 'Select Type' },
                { value: 1, text: 'HTTP Basic' },
                { value: 2, text: 'Digest' }
            ],
            grace_timeout_datas: [30, 60, 120, 180, 300, 600, 1200, 1800, 3600, 7200, 10800, 18000, 36000, 54000, 72000, 86400],
            timeout_datas: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60],
            interval_datas: [1, 2, 3, 5, 6, 10, 12, 15, 20, 30, 60, 120, 180, 240, 360, 480, 720, 1440],
            interval_datas_page_load: [60, 120, 180, 240, 360, 480, 720, 1440],
            interval_datas_screen_shot: [180, 240, 360, 480, 720, 1440],
            interval_datas_heartbeat_minutes: [1, 2, 3, 4, 5, 6, 10, 12, 15, 20, 30],
            interval_datas_heartbeat_hours: [1, 2, 3, 4, 6, 8, 12, 24],
            interval_datas_heartbeat_day: 1,
            interval_opt: ['Minute', 'Hour', 'Day'],
            interval_type: 'Minute',
            grace_time_in: 1,
            not_premium: false,
            custom_header_counter: 0,
            custom_headers: [],
            plan_details: { minIntervalLimit: 5 },
            alertContacts: [],
            alerts: [],
            hertbeat_url: '',
            hertbeat_id: '',
            show_hertbeat_url: false,
            sliderValue: 50,
            width: 50,
            payload: {},
            show_custom_port: true,
            monitor_input: {
                name: '',
                type: null,
                url: '',
                interval: 1,
                timeout: 30,
                ssl_error: false,
                ssl_expiry_reminder: false,
                http_method: 'GET',
                auth_type: 1,
                up_status: [100, 103, 200, 201, 202, 203, 204, 205, 206, 207, 208, 226, 300, 301, 302, 303, 304, 305, 306, 307, 308],
                down_status: [400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 421, 422, 423, 424, 425, 426, 428, 429, 430, 431, 440, 449, 450, 451, 495, 496, 497, 499, 500, 501, 502, 503, 504, 505, 508, 509, 510, 511, 520, 521, 522, 523, 524, 525, 526, 527, 530, 598, 599],
                custom_header: [],
                keyword: '',
                case_sensitive: false,
                alertWhen: 1,
                port: null,
                custom_port: 1,
                devicetype: null,
                alertContacts: [],
                downAlertFreqType: 0,
                grace_interval: 30,
                proxyUrl: '',
                postContentType: 1,
                mwids: [],
                dayCount: 1,
                auth_username: '',
                auth_password: '',
            },
            device_type_opt: [
                { value: null, text: 'Please Select' },
                { value: '1', text: 'Desktop' },
                { value: '2', text: 'Mobile' },
                { value: '3', text: 'Tablet' },
            ],
            monitor_type_opt: [
                { value: null, text: 'Select Monitor Type' },
                { value: '1', text: 'HTTP(s)', disabled: true },
                { value: '2', text: 'Keyword', disabled: true },
                { value: '3', text: 'Ping', disabled: true },
                { value: '4', text: 'Port', disabled: true },
                { value: '5', text: 'Heartbeat', disabled: true },
                { value: '6', text: 'Page Speed', disabled: true },
                { value: '7', text: 'Page Screenshot', disabled: true },
            ],
            alert_freq_opt: [
                { value: null, text: 'select frequency' },
                { value: 0, text: 'once' },
                { value: 1, text: 'once per hour' },
                { value: 2, text: 'once per day' },
                { value: 3, text: 'once per week' },
                { value: 4, text: 'once per month' },
            ],
            port_opt: [
                { value: null, text: 'Please Select' },
                { value: '80', text: 'HTTP(80)' },
                { value: '443', text: 'HTTPS(443)' },
                { value: '21', text: 'FTP(21)' },
                { value: '25', text: 'SMTP(25)' },
                { value: '110', text: 'POP3(110)' },
                { value: '143', text: 'IMAP(143)' },
                { value: '0', text: 'Custom Port' }
            ],
            invalid_fname_message: 'The name field is required',
            invalid_url_message: 'The given URL/IP has an invalid character',
            invalid_keyword_message: 'The keyword field is required',
            invalid_proxy_url_message: '',
            invalid_port_message: 'Please select a port',
            invalid_devicetype_message: 'Please select a device type',
            invalid_type_message: 'Please select a monitor type',
            invalid_username_message: '',
            headerKeyPattern: /^[a-zA-Z0-9\-!#$%&'*+.^_`|~]+$/,
            headerValuePattern: /^[\x09\x20-\x7e\x80-\xff]*$/,
            maintenance_list: [],
            selectedMaintenanceWindows: [],
            post_data_type: 1,
            post_key_val_data: [],
            post_row_data: '',
            postContentType: false,
            isNameEntered: false,
            isUrlEntered: false,
            isKeywordEntered: false,
            isProxyUrlEntered: false,
            isPortSelected: false,
            isCustomPortEntered: false,
            isDeviceTypeSelected: false,
            isTypeSelected: false,
            isUsernameEntered: false,
            onLoading: false,
            intervalIndex: 0,
            intervalUnit: 'minutes',
            timeoutUnit: 'seconds',
            timeoutIndex: 29, // Default to 30 seconds (index 29 in timeout_datas)
            graceTimeoutIndex: 0, // Default to 30 seconds (index 0 in grace_timeout_datas)
            showAdvancedSettings: false,
            showMaintenanceWindows: false,
            showAlertDropdown: false,
            alertSearchQuery: '',
            showMaintenanceDropdown: false,
            maintenanceSearchQuery: '',
            accordionStates: {
                auth: false,
                httpStatus: false,
                headers: false,
                proxy: false
            },
        };
    },
    watch: {
        'monitor_input.type': function(newType, oldType) {
            if (!newType) return;
            
            // When type changes, ensure interval meets minimum requirements
            if (newType == '6') {
                // Page Speed: minimum 60 minutes (1 hour)
                if (this.monitor_input.interval < 60) {
                    this.monitor_input.interval = 60;
                    this.updateIntervalIndex();
                    this.updateIntervalUnit();
                }
            } else if (newType == '7') {
                // Page Screenshot: minimum 180 minutes (3 hours)
                if (this.monitor_input.interval < 180) {
                    this.monitor_input.interval = 180;
                    this.updateIntervalIndex();
                    this.updateIntervalUnit();
                }
            }
        }
    },
    computed: {
        validate_type() {
            return this.monitor_input.type !== null;
        },
        validate_passwordlimit() {
            if (this.monitor_input.auth_password) {
                return this.monitor_input.auth_password.length <= 25;
            }
            return null;
        },
        validatePort() {
            if (this.monitor_input.port == 0) {
                // Validate custom port range (1-65535)
                const port = parseInt(this.monitor_input.custom_port);
                return port >= 1 && port <= 65535;
            }
            return null;
        },
        inputPlaceholder() {
            if(this.monitor_input.type == '1' || this.monitor_input.type == '2' || this.monitor_input.type == '6' || this.monitor_input.type == '7'){
                return 'URL'
            } else {
                return 'Domain or IP'
            }
        },
        showAdditionalFields() {
            return this.monitor_input.type != null && this.monitor_input.name.trim() !== '';
        },
        canSubmit() {
            // Basic required fields
            if (this.monitor_input.type == null || !this.monitor_input.name || this.monitor_input.name.trim() === '') {
                return false;
            }
            
            // Check name validation
            if (this.isNameEntered && this.invalid_fname_message) {
                return false;
            }
            
            // If additional fields are shown, validate them
            if (this.showAdditionalFields) {
                // URL/IP validation for non-heartbeat monitors
                if (this.monitor_input.type != 5) {
                    if (!this.monitor_input.url || this.monitor_input.url.trim() === '') {
                        return false;
                    }
                    if (this.isUrlEntered && this.invalid_url_message) {
                        return false;
                    }
                }
                
                // Keyword validation for keyword monitor
                if (this.monitor_input.type == 2) {
                    if (!this.monitor_input.keyword || this.monitor_input.keyword.trim() === '') {
                        return false;
                    }
                    if (this.isKeywordEntered && this.invalid_keyword_message) {
                        return false;
                    }
                }
                
                // Port validation for port monitor
                if (this.monitor_input.type == 4) {
                    if (this.monitor_input.port == null || this.monitor_input.port === '') {
                        return false;
                    }
                    if (this.monitor_input.port == 0 && (!this.monitor_input.custom_port || this.monitor_input.custom_port === '')) {
                        return false;
                    }
                    if (this.isPortSelected && this.invalid_port_message) {
                        return false;
                    }
                }
                
                // Device type validation for screenshot monitor
                if (this.monitor_input.type == 7) {
                    if (!this.monitor_input.devicetype || this.monitor_input.devicetype === '') {
                        return false;
                    }
                    if (this.isDeviceTypeSelected && this.invalid_devicetype_message) {
                        return false;
                    }
                }

                // Alert frequency validation - ensure a valid frequency is selected
                if (this.monitor_input.downAlertFreqType === null) {
                    return false;
                }
            }
            
            return true;
        },
        currentIntervalData() {
            if (this.monitor_input.type == 6) {
                return this.interval_datas_page_load;
            } else if (this.monitor_input.type == 7) {
                return this.interval_datas_screen_shot;
            } else {
                return this.interval_datas;
            }
        },
        intervalDisplayValue() {
            const val = this.monitor_input.interval;
            if (val < 60) return val;
            return val / 60;
        },
        timeoutDisplayValue() {
            return this.monitor_input.timeout;
        },
        graceTimeoutDisplayValue() {
            const val = this.monitor_input.grace_interval;
            if (val < 60) return val;
            if (val < 3600) return Math.floor(val / 60);
            return Math.floor(val / 3600);
        },
        graceTimeoutUnit() {
            const val = this.monitor_input.grace_interval;
            if (val < 60) return 'seconds';
            if (val < 3600) return 'minutes';
            return 'hours';
        },
        alertSelectText() {
            if(!this.alertContacts || this.alertContacts.length === 0) {
                return 'Select Alert Contacts';
            }
            return `${this.alertContacts.length} contact${this.alertContacts.length > 1 ? 's' : ''} selected`;
        },
        filteredAlertsList() {
            if(!this.alertSearchQuery) {
                return this.alerts;
            }
            return this.alerts.filter(alert => 
                alert.text.toLowerCase().includes(this.alertSearchQuery.toLowerCase())
            );
        },
        maintenanceSelectText() {
            if(!this.selectedMaintenanceWindows || this.selectedMaintenanceWindows.length === 0) {
                return 'Select Maintenance Windows';
            }
            return `${this.selectedMaintenanceWindows.length} window${this.selectedMaintenanceWindows.length > 1 ? 's' : ''} selected`;
        },
        filteredMaintenanceList() {
            if(!this.maintenanceSearchQuery) {
                return this.maintenance_list;
            }
            return this.maintenance_list.filter(maintenance => 
                maintenance.text.toLowerCase().includes(this.maintenanceSearchQuery.toLowerCase())
            );
        }
    },
    created() {
        this.plan_details = this.$root.$data.plan_details;
        
        // Use the correct property name: monitorTypes (not monitorsTypes)
        for (var i = 0; i < this.monitor_type_opt.length; i++) {
            this.plan_details.monitorTypes.map((mt) => {
                if (this.monitor_type_opt[i].value == mt) {
                    this.monitor_type_opt[i].disabled = false;
                }
            })
        }
    },
    async mounted() {
        if (this.plan_details.plan_type == '1') {
            this.not_premium = true;
        }
        
        // Load data in parallel
        await Promise.all([
            this.getAlerts(),
            this.getMaintenanceWindows()
        ]);

        // If editing, load the monitor data after alerts and maintenance windows are loaded
        if (this.edit_monitor && this.monitor_data) {
            this.loadMonitorData();
        }
        
        // Initialize indices
        this.updateIntervalIndex();
        this.updateTimeoutIndex();
        this.updateGraceTimeoutIndex();
        
        // Ensure grace_interval is set to first value in array if it's a new monitor
        if (!this.edit_monitor) {
            this.monitor_input.grace_interval = this.grace_timeout_datas[0]; // 30
            this.graceTimeoutIndex = 0;
        }
        
        // Close dropdown when clicking outside
        document.addEventListener('click', this.closeDropdownOnClickOutside);
        // Handle scroll and resize for dropdown positioning
        window.addEventListener('scroll', this.handleScroll, true);
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdownOnClickOutside);
        window.removeEventListener('scroll', this.handleScroll, true);
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        validateType() {
            this.isTypeSelected = true;
            if (!this.monitor_input.type) {
                this.invalid_type_message = 'Please select a monitor type';
            } else {
                this.invalid_type_message = '';
                
                // Set minimum interval for Page Speed and Page Screenshot monitors
                if (this.monitor_input.type == '6') {
                    // Page Speed: minimum 60 minutes (1 hour)
                    if (this.monitor_input.interval < 60) {
                        this.monitor_input.interval = 60;
                        this.updateIntervalIndex();
                        this.updateIntervalUnit();
                    }
                } else if (this.monitor_input.type == '7') {
                    // Page Screenshot: minimum 180 minutes (3 hours)
                    if (this.monitor_input.interval < 180) {
                        this.monitor_input.interval = 180;
                        this.updateIntervalIndex();
                        this.updateIntervalUnit();
                    }
                }
            }
        },
        validateName() {
            this.isNameEntered = true;
            if (!this.monitor_input.name || this.monitor_input.name.trim() === '') {
                this.invalid_fname_message = 'The name field is required';
            } else if (this.monitor_input.name.length > 50) {
                this.invalid_fname_message = 'Name must be less than 50 characters';
            } else {
                this.invalid_fname_message = '';
            }
        },
        validate_url() {
            if (this.monitor_input.url) {
                this.isUrlEntered = true;
                this.show_SSL = this.monitor_input.url.startsWith('https');
                if(!this.show_SSL){
                this.monitor_input.ssl_error = this.monitor_input.ssl_expiry_reminder = false
               }
            }
            return this.validation()
        },
        validation(){
            if(this.monitor_input.type == '1' || this.monitor_input.type == '2' || this.monitor_input.type == '6' || this.monitor_input.type == '7'){
                this.invalid_url_message = 'Please enter valid URL with http:// or https://'
            
                let urlValidate = this.isValidURL(this.monitor_input.url)
                let proxyUrlValidate = this.monitor_input.proxyUrl ? this.isValidProxyURL(this.monitor_input.proxyUrl) : true
                let validRowData = this.validatePostRowData(this.post_row_data)
                if (urlValidate && proxyUrlValidate) {
                    if (this.post_row_data) {
                        if (validRowData) {
                            this.payload['postValue'] = this.post_row_data;
                            return true
                        } else {
                            this.invalid_url_message = 'Please enter valid Row data'
                            return false
                        }
                    } 
                    this.invalid_url_message =''
                    return true;
                } else {
                return false;
            }
            }
            else if(this.monitor_input.type == '3' || this.monitor_input.type == '4'){
                this.invalid_url_message = 'Please enter valid domain or IP address'

                if (this.validateIp(this.monitor_input.url) || this.validateDomain(this.monitor_input.url)) {
                    this.invalid_url_message = ''
                    return true;
                } else {
                    return false;
                }
            }
            else if(this.monitor_input.type == '5'){
                return true;
            }
            else{
                if (this.validateIp(this.monitor_input.url) || this.validateDomain(this.monitor_input.url) || this.isValidURL(this.monitor_input.url)) {
        
                    return true;
            } else {
                    return false;
                }
            }
        },
        validate_keyword() {
            this.isKeywordEntered = true;
            if (!this.monitor_input.keyword || this.monitor_input.keyword.trim() === '') {
                this.invalid_keyword_message = 'The keyword field is required';
            } else {
                this.invalid_keyword_message = '';
            }
        },
        validate_proxy_url() {
            if (this.monitor_input.proxyUrl) {
                this.isProxyUrlEntered = true;
                if (!this.isValidProxyURL(this.monitor_input.proxyUrl)) {
                    this.invalid_proxy_url_message = 'Please enter valid Proxy URL with http://, https://, socks4:// or socks5://';
                } else {
                    this.invalid_proxy_url_message = '';
                }
            } else {
                this.isProxyUrlEntered = false;
                this.invalid_proxy_url_message = '';
            }
        },
        validate_port() {
            this.isPortSelected = true;
            if (!this.monitor_input.port) {
                this.invalid_port_message = 'Please select a port';
            } else {
                this.invalid_port_message = '';
            }
            
            // Enable custom port field only when "Custom Port" is selected (value 0)
            this.show_custom_port = this.monitor_input.port != 0;
            
            // If a specific port is selected, update custom_port field with that value
            if (this.monitor_input.port && this.monitor_input.port != 0) {
                this.monitor_input.custom_port = this.monitor_input.port;
            }
        },
        validateCustomPort() {
            this.isCustomPortEntered = true;
        },
        validate_deviceType() {
            this.isDeviceTypeSelected = true;
            if (!this.monitor_input.devicetype) {
                this.invalid_devicetype_message = 'Please select a device type';
            } else {
                this.invalid_devicetype_message = '';
            }
        },
        validate() {
            if (this.monitor_input.auth_username) {
                this.isUsernameEntered = true;
                if (this.monitor_input.auth_username.length > 50) {
                    this.invalid_username_message = 'Username must be less than 50 characters';
                } else {
                    this.invalid_username_message = '';
                }
            }
        },
        async getAlerts(){
            let response= await MonitorController.getAlerts()
            this.alerts = []; // Clear the alerts array first
            if (response.data) {
                response.data.map((t) => {
                    if (t.status) {
                        let iconClass = '';
                        let iconImage = '';
                        let isImage = false;
                        switch (t.type) {
                            case 1:
                                iconClass = 'icofont icofont-envelope'; // Email
                                break;
                            case 2:
                                iconClass = 'icofont icofont-social-skype'; // Skype
                                break;
                            case 3:
                                iconClass = 'icofont icofont-social-telegram'; // Telegram
                                break;
                            case 4:
                                iconClass = 'icofont icofont-web'; // Webpush
                                break;
                            case 5:
                                iconClass = 'icofont icofont-globe-alt'; // Webhook
                                break;
                            case 6:
                                iconClass = 'icofont icofont-ui-messaging'; // Message
                                break;
                            case 7:
                                iconClass = 'icofont icofont-phone'; // Call
                                break;
                            case 8:
                                iconImage = require('@/assets/icons/icon-slack.png'); //Slack
                                isImage = true;
                                break;
                            case 9:
                                iconClass = 'icofont icofont-wheel'; // Zappier
                                break;
                            case 10:
                                iconImage = require('@/assets/icons/icon-zulip.png'); //zulip
                                isImage = true;
                                break;
                            case 11:
                                iconImage = require('@/assets/icons/icon-teams.png'); //teams
                                isImage = true;
                                break;
                            default:
                                iconClass = ''; 
                        }

                        this.alerts.push({
                            value: t._id,
                            text: t.name,
                            icon: iconClass,
                            isImage: isImage,
                            image: iconImage
                        });
                    }
                });
            }
            // Alert contacts will be set in loadMonitorData after monitor data is loaded
        },
        async getMaintenanceWindows() {
            try {
                let response = await MaintenanceController.getAll();
                if (response.result && response.data) {
                    this.maintenance_list = response.data.map(m => ({
                        value: m._id,
                        text: m.name,
                        badge: m.status ? 'Active' : 'Inactive'
                    }));
                }
            } catch (error) {
                console.error('Error fetching maintenance windows:', error);
            }
        },
        validateHeaderKey(index) {
            const header = this.custom_headers[index];
            if (!header || !header.key) return;
            
            if (!this.headerKeyPattern.test(header.key)) {
                this.$set(header, 'keyError', "Invalid header key");
            } else {
                this.$set(header, 'keyError', "");
            }
        },
        validateHeaderValue(index) {
            const header = this.custom_headers[index];
            if (!header || !header.value) return;
            
            if (!this.headerValuePattern.test(header.value)) {
                this.$set(header, 'valueError', "Invalid header value");
            } else {
                this.$set(header, 'valueError', "");
            }
        },
        updateAuth(type) {
            this.monitor_input.auth_type = type;
            this.authKey++;
        },
        MoveStatus(direction, status) {
            if (direction === 'right') {
                const index = this.monitor_input.up_status.indexOf(status);
                if (index > -1) {
                    this.monitor_input.up_status.splice(index, 1);
                    this.monitor_input.down_status.push(status);
                }
            } else {
                const index = this.monitor_input.down_status.indexOf(status);
                if (index > -1) {
                    this.monitor_input.down_status.splice(index, 1);
                    this.monitor_input.up_status.push(status);
                }
            }
        },
        fancyTimeFormat(time) {
            const hrs = Math.floor(time / 3600);
            const mins = Math.floor((time % 3600) / 60);
            const secs = time % 60;
            
            if (hrs > 0) {
                return hrs;
            } else if (mins > 0) {
                return mins;
            } else {
                return secs;
            }
        },
        changeDateFormate(date) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
        },
        checkIntervallimit() {
            if (this.plan_details.minIntervalLimit > this.monitor_input.interval) {
                this.$toasted.show('Interval cannot be less than ' + this.plan_details.minIntervalLimit + ' minute.', {
                    theme: 'outline',
                    position: "bottom-center",
                    type: 'error',
                    duration: 2000
                });
                this.monitor_input.interval = this.plan_details.minIntervalLimit;
                this.sliderKey++;
            }
        },
        addTag(newTag) {
            const tag = {
                value: newTag,
                text: newTag
            };
            this.alerts.push(tag);
            this.alertContacts.push(tag);
        },
        loadMonitorData() {
            if (this.monitor_data) {
                Object.assign(this.monitor_input, this.monitor_data);
                // Set alertContacts by filtering the alerts array with the monitor's alertContacts IDs
                if (this.monitor_input.alertContacts && this.alerts.length > 0) {
                    this.alertContacts = this.alerts.filter(alert => 
                        this.monitor_input.alertContacts.includes(alert.value)
                    );
                }
                if (this.monitor_data.mwids) {
                    this.selectedMaintenanceWindows = this.maintenance_list.filter(m => 
                        this.monitor_data.mwids.includes(m.value)
                    );
                }
                if (this.monitor_data.custom_header && this.monitor_data.custom_header.length > 0) {
                    this.custom_headers = [];
                    this.monitor_data.custom_header.forEach(header => {
                        const key = Object.keys(header)[0];
                        const value = header[key];
                        this.custom_headers.push({ key: key, value: value });
                    });
                }

                // Handle POST/PUT data for HTTP methods
                if (this.monitor_data.postType) {
                    this.post_data_type = this.monitor_data.postType;
                }

                if (this.monitor_data.postContentType) {
                    this.postContentType = this.monitor_data.postContentType === 2;
                }

                if (this.monitor_data.postValue) {
                    if (this.post_data_type == 1) {
                        // Key/Value mode - parse JSON string back to object
                        try {
                            const parsedData = JSON.parse(this.monitor_data.postValue);
                            this.post_key_val_data = [];
                            for (const [key, value] of Object.entries(parsedData)) {
                                this.post_key_val_data.push({ key: key, value: value });
                            }
                        } catch (e) {
                            console.error('Error parsing postValue:', e);
                        }
                    } else if (this.post_data_type == 2) {
                        // Raw data mode - use as is
                        this.post_row_data = this.monitor_data.postValue;
                    }
                }

                // Handle port monitor data
                if (this.monitor_input.type == 4 && this.monitor_input.port) {
                    // Check if the port exists in the predefined options
                    const result = this.port_opt.find(({value}) => value == this.monitor_input.port);
                    this.monitor_input.custom_port = this.monitor_input.port;
                    
                    if (!result) {
                        // If port is not in the list, it's a custom port
                        this.monitor_input.custom_port = this.monitor_input.port;
                        this.monitor_input.port = '0'; // Set to Custom Port option
                    }
                }
                
                // Ensure interval is valid for monitor type before updating indices
                if (this.monitor_input.type == 6) {
                    // Page Speed: minimum 60 minutes (1 hour)
                    if (this.monitor_input.interval < 60) {
                        this.monitor_input.interval = 60;
                    }
                } else if (this.monitor_input.type == 7) {
                    // Page Screenshot: minimum 180 minutes (3 hours)
                    if (this.monitor_input.interval < 180) {
                        this.monitor_input.interval = 180;
                    }
                }
                
                // Update indices after loading data
                this.updateIntervalIndex();
                this.updateIntervalUnit(); // Update unit display (minutes/hours)
                this.updateTimeoutIndex();
                this.updateGraceTimeoutIndex();
                
                // Set validation flags for pre-filled fields to show validation icons
                if (this.monitor_input.type) {
                    this.isTypeSelected = true;
                    this.invalid_type_message = '';
                }
                
                if (this.monitor_input.name) {
                    this.isNameEntered = true;
                    this.invalid_fname_message = '';
                }
                
                if (this.monitor_input.url && [1, 2, 3].includes(this.monitor_input.type)) {
                    this.isUrlEntered = true;
                    this.invalid_url_message = '';
                }
                
                if (this.monitor_input.keyword && this.monitor_input.type == 2) {
                    this.isKeywordEntered = true;
                    this.invalid_keyword_message = '';
                }
                
                if (this.monitor_input.type == 4) {
                    if (this.monitor_input.port == '0' && this.monitor_input.custom_port) {
                        this.isCustomPortEntered = true;
                    } else if (this.monitor_input.port) {
                        this.isPortSelected = true;
                        this.invalid_port_message = ''; // Clear any error message
                    }
                    // Update show_custom_port flag based on the loaded port value
                    // This is critical for the canSubmit computed property to work correctly
                    this.show_custom_port = this.monitor_input.port != 0;
                }
                
                if (this.monitor_input.devicetype && this.monitor_input.type == 7) {
                    this.isDeviceTypeSelected = true;
                    this.invalid_devicetype_message = '';
                }
                
                if (this.monitor_input.proxyUrl) {
                    this.isProxyUrlEntered = true;
                    this.invalid_proxy_url_message = '';
                }
            }
        },
        async onSubmit(txt){
            // Check if additional fields are shown (new flow requirement)
            if (!this.showAdditionalFields) {
                return;
            }
            
            this.onLoading = true
            if(this.validate()){
            this.payload={}
            this.monitor_input.alertContacts=[]
            this.alertContacts.map((l)=>{
                this.monitor_input.alertContacts.push(l.value)
            })
            this.monitor_input.custom_header = []
            var c_headers = []
            for(let i=0; i<this.custom_headers.length; i++) {
                if((this.custom_headers[i]["key"] && this.custom_headers[i]["value"]) !='')
                c_headers.push({ [this.custom_headers[i]["key"]] : this.custom_headers[i]["value"]})
                }
            this.monitor_input.custom_header = c_headers
            switch(this.monitor_input.type.toString()){
                case '1':
                    this.payload = {"name": this.monitor_input.name,"type": this.monitor_input.type,"url": this.monitor_input.url,"interval": this.monitor_input.interval,"timeout": this.monitor_input.timeout,"ssl_error": this.monitor_input.ssl_error,"ssl_expiry_reminder": this.monitor_input.ssl_expiry_reminder,"auth_type": this.monitor_input.auth_type,"auth_username": this.monitor_input.auth_username,"auth_password": this.monitor_input.auth_password,"http_method": this.monitor_input.http_method,"up_status": this.monitor_input.up_status,"down_status": this.monitor_input.down_status,"custom_header":this.monitor_input.custom_header,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,'proxyUrl':this.monitor_input.proxyUrl}
                    this.checkCustomPostData()
                    break;
                case '2':
                    this.payload = {"name": this.monitor_input.name,"type": this.monitor_input.type,"url": this.monitor_input.url,"interval": this.monitor_input.interval,"timeout": this.monitor_input.timeout,"ssl_error": this.monitor_input.ssl_error,"ssl_expiry_reminder": this.monitor_input.ssl_expiry_reminder,"auth_type": this.monitor_input.auth_type,"auth_username": this.monitor_input.auth_username,"auth_password": this.monitor_input.auth_password,"http_method": this.monitor_input.http_method,"alertWhen":this.monitor_input.alertWhen,"case_sensitive": this.monitor_input.case_sensitive,"keyword": this.monitor_input.keyword,"custom_header":this.monitor_input.custom_header,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,'proxyUrl':this.monitor_input.proxyUrl}
                    this.checkCustomPostData()
                    break;
                case '3':
                    this.payload = {"name": this.monitor_input.name,"type": this.monitor_input.type,"url": this.monitor_input.url,"interval": this.monitor_input.interval,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,}
                    break;
                case '4':
                    var port = this.monitor_input.port
                    if(this.monitor_input.port == 0){
                        port = this.monitor_input.custom_port
                    }
                    this.payload = {"name": this.monitor_input.name,"type": this.monitor_input.type,"url": this.monitor_input.url,
                    "port":port,"interval": this.monitor_input.interval,"timeout": this.monitor_input.timeout,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,}
                    break;
                case '5': //Heartbeat payload
                    this.payload = {"name" : this.monitor_input.name, "type": this.monitor_input.type, "interval": this.monitor_input.interval,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,"grace_interval":this.monitor_input.grace_interval}
                    switch(this.interval_type){
                        case 'Minute':
                            this.payload = {"name" : this.monitor_input.name, "type": this.monitor_input.type, "interval": this.monitor_input.interval,"dayCount":0,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,"grace_interval":this.monitor_input.grace_interval}
                            break;
                        case 'Hour':
                            let interval_hour = this.monitor_input.interval * 60
                            this.payload = {"name" : this.monitor_input.name, "type": this.monitor_input.type, "interval": interval_hour,"dayCount":0,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,"grace_interval":this.monitor_input.grace_interval}
                            break;
                        case 'Day':
                            let interval_minutes = 24 * 60
                            this.payload = {"name" : this.monitor_input.name, "type": this.monitor_input.type, "interval": interval_minutes,"dayCount":this.monitor_input.dayCount,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,"grace_interval":this.monitor_input.grace_interval}
                            break;
                        }
                    break;
                case '6':
                    this.payload = {"type": this.monitor_input.type,"name" : this.monitor_input.name, "interval": this.monitor_input.interval,"url": this.monitor_input.url,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,"timeout": this.monitor_input.timeout}
                    break;
                case '7':
                    this.payload = {"type": this.monitor_input.type,"name" : this.monitor_input.name, "interval": this.monitor_input.interval,"timeout": this.monitor_input.timeout,"url": this.monitor_input.url,'devicetype':this.monitor_input.devicetype,"alertContacts":this.monitor_input.alertContacts,"downAlertFreqType":this.monitor_input.downAlertFreqType,}
                break;
            }
            this.payload.mwids = []
            if(this.selectedMaintenanceWindows && this.selectedMaintenanceWindows.length > 0){
                this.selectedMaintenanceWindows.map((t)=>{
                    this.payload.mwids.push(t.value)
                })
            }
            if(Object.keys(this.payload).length > 0){
                var response
                try {
                    if (this.edit_monitor) {
                        const p = { mid: this.monitor_input._id, changePayload: this.payload };
                        response = await MonitorController.editMonitor(p);
                    } else {
                        response = await MonitorController.createMonitor(this.payload);
                        if (response.result && this.monitor_input.type == 5) {
                            this.hertbeat_id = response.data.mid;
                        }
                    }

                    if (response.result) {
                        // Track monitor events in PostHog
                        if (this.edit_monitor) {
                            monitorEvents.updated(this.monitor_input, this.payload);
                        } else {
                            monitorEvents.created(this.payload);
                        }
                        this.show_hertbeat_url = false;
                        if (!txt) this.$emit('monitormodal');

                        this.$toasted.show(response.message, { theme: 'outline', position: "bottom-center", type: 'success', duration: 3000
                        });
                        } else {
                        this.$toasted.show(response.message, { theme: 'outline', position: "bottom-center", type: 'error', duration: 2000
                        });
                    }
                } catch (error) {
                    this.$toasted.show(error.message || 'An error occurred', { theme: 'outline', position: "bottom-center", type: 'error', duration: 2000 });
                } finally {
                    this.onLoading = false;
                }
            } else {
                this.onLoading = false;
            }
        } else {
            this.onLoading = false;
        }
        },
        validateForm() {
            return this.validate();
        },
        validate(){
            let nameValidate = this.validateName(this.monitor_input.name)
            let urlValidate = this.validation() || this.monitor_input.type == 5
            let keywordValidate = true
            
            // Check keyword validation for keyword monitor type
            if (this.monitor_input.type == 2) {
                this.validate_keyword()
                keywordValidate = !this.invalid_keyword_message
            }
            
            if(urlValidate && nameValidate && keywordValidate) {
                return true
            } else if(!nameValidate) {
                this.$toasted.show(this.invalid_fname_message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                return false
            } else if(!urlValidate) {
                this.$toasted.show(this.invalid_url_message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                return false
            } else if(!keywordValidate) {
                this.$toasted.show(this.invalid_keyword_message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                return false
            } else {
                this.$toasted.show('Please fill all required fields', {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                return false
            }
        },
        isValidURL(url) {
            try {
                // Check for spaces in the original URL string
                if (url.includes(' ')) {
                    return false;
                }

                // Attempt to create a new URL object
                let x = new URL(url);
                if(!(x.protocol == 'http:' || x.protocol == 'https:')) {
                    return false
                }

                // Decode fragment (hash) safely
                if (x.hash) {
                    try {
                        decodeURIComponent(x.hash.substring(1)); 
                    } catch (decodeErr) {
                        testBugger.errorLog('Invalid fragment encoding');
                        return false; // invalid fragment
                    }
                }

                let pattern = this.getURLValidationRegex(['http', 'https']);

                return pattern.test(url);
            } catch (err) {
                console.error('Error in URL validation')
                console.error(err)
                return false
            }
        },

        isValidProxyURL(url) {
            try {
                // Check for spaces in the original URL string
                if (url.includes(' ')) {
                    return false;
                }

                // Attempt to create a new URL object
                let x = new URL(url);
                if(!(x.protocol == 'http:' || x.protocol == 'https:' || x.protocol == 'socks4:' || x.protocol == 'socks5:')) {
                        return false;
                }

                // Decode fragment (hash) safely
                if (x.hash) {
                    try {
                        decodeURIComponent(x.hash.substring(1)); 
                    } catch (decodeErr) {
                        testBugger.errorLog('Invalid fragment encoding');
                        return false; // invalid fragment
                    }
                }

                let pattern = this.getURLValidationRegex(['http', 'https', 'socks4', 'socks5']);

                return pattern.test(url);
            } catch (err) {
                console.error('Error in URL validation')
                console.error(err)
                return false
            }
        },

        getURLValidationRegex(allowedProtocols = ['http', 'https']) {
            const protocolPattern = `^(${allowedProtocols.join('|')}):\\/\\/`; // dynamic protocols

            // Unicode safe ranges (exclude emoji and surrogates)
            // Includes: Latin extended, Cyrillic, Greek, Arabic, Hebrew, CJK, Indic scripts, Thai
            // Excludes: \u2600-\u27bf (emoji blocks), \ud800-\udfff (surrogates)
            const domainStartEnd = '[a-zA-Z0-9\\u00a1-\\u2599\\u2800-\\ud7ff\\ue000-\\uffff]';
            const domainMiddle = '[a-zA-Z0-9\\u00a1-\\u2599\\u2800-\\ud7ff\\ue000-\\uffff.-]';

            return new RegExp(
                protocolPattern +                              // protocol (http, https)
                '([^@\\/\\s]+(:[^@\\/\\s]*)?@)?' +            // optional credentials (no spaces)
                '(' +                                          // start host group
                    '((25[0-5]|2[0-4][0-9]|[01]?\\d\\d?)\\.){3}' +
                    '(25[0-5]|2[0-4][0-9]|[01]?\\d\\d?)' +      // IPv4 address
                    '|' +
                    '(' + domainStartEnd +                     // domain must start with alphanumeric
                    '(' + domainMiddle + '*' + domainStartEnd + ')?' + // middle can have hyphens/dots
                    '\\.)+'  +                                  // domain labels separated by dots
                    domainStartEnd + '{2,}' +                  // TLD at least 2 chars
                    '|' +
                    '\\[([a-fA-F\\d:]+)\\]' +                  // IPv6 in brackets
                ')' +                                          // end host group
                '(:(\\d{1,5}))?' +                             // optional port (1-5 digits)
                '(\\/[^\\s]*)?' +                              // optional path (no spaces)
                '(\\?[^\\s]*)?' +                              // optional query (no spaces)
                '(#[^\\s]*)?',                                 // optional fragment (no spaces)
                'i'
            );
        },
        validateIp(ipaddress){
            if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {  
                return true;
            }
            return false;
        },
        validateDomain(domain){
            var regexp = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i;
            if (regexp.test(domain)){ return true; }
            else{ return false; }
        },
        validateName(name){
            this.isNameEntered = true;
            name = name ? name : this.monitor_input.name

            let regexp = /^(?!\s*$)[a-zA-Z0-9 ._-]+$/;
            if (regexp.test(name)) {
                this.invalid_fname_message = false;
                    return true;
            } 
            else{ 
                this.invalid_fname_message = 'Please enter valid friendly name';
                    return false;
                }
        },
        validatePostRowData(data) {
            try { 
                data = JSON.parse(data)
                if(typeof data === 'object' && !Array.isArray(data)){
                    return true
                }
            } catch (r) {
                return false
            }
            return false
        },
        changeDateFormate(d){
            return moment(d).format('D/M/YYYY, h:mm A')
        },
        incrementInterval() {
            if (this.intervalIndex < this.currentIntervalData.length - 1) {
                this.intervalIndex++;
                this.monitor_input.interval = this.currentIntervalData[this.intervalIndex];
                this.updateIntervalUnit();
                this.checkIntervallimit();
            }
        },
        decrementInterval() {
            if (this.intervalIndex > 0) {
                this.intervalIndex--;
                this.monitor_input.interval = this.currentIntervalData[this.intervalIndex];
                this.updateIntervalUnit();
                this.checkIntervallimit();
            }
        },
        updateIntervalUnit() {
            this.intervalUnit = this.monitor_input.interval < 60 ? 'minutes' : 'hours';
        },
        updateIntervalIndex() {
            const currentData = this.currentIntervalData;
            const idx = currentData.indexOf(this.monitor_input.interval);
            if (idx === -1) {
                // Find closest value
                let closestIndex = 0;
                let closestDiff = Math.abs(currentData[0] - this.monitor_input.interval);
                for (let i = 1; i < currentData.length; i++) {
                    const diff = Math.abs(currentData[i] - this.monitor_input.interval);
                    if (diff < closestDiff) {
                        closestDiff = diff;
                        closestIndex = i;
                    }
                }
                this.intervalIndex = closestIndex;
                this.monitor_input.interval = currentData[closestIndex];
            } else {
                this.intervalIndex = idx;
            }
            this.updateIntervalUnit();
        },
        incrementTimeout() {
            if (this.timeoutIndex < this.timeout_datas.length - 1) {
                this.timeoutIndex++;
                this.monitor_input.timeout = this.timeout_datas[this.timeoutIndex];
            }
        },
        decrementTimeout() {
            if (this.timeoutIndex > 0) {
                this.timeoutIndex--;
                this.monitor_input.timeout = this.timeout_datas[this.timeoutIndex];
            }
        },
        validateTimeout() {
            if (this.monitor_input.timeout < 1) {
                this.monitor_input.timeout = 1;
                this.timeoutIndex = 0;
            } else if (this.monitor_input.timeout > 60) {
                this.monitor_input.timeout = 60;
                this.timeoutIndex = this.timeout_datas.length - 1;
            }
            this.updateTimeoutIndex();
        },
        updateTimeoutIndex() {
            const idx = this.timeout_datas.indexOf(this.monitor_input.timeout);
            if (idx === -1) {
                // Find closest value
                let closestIndex = 0;
                let closestDiff = Math.abs(this.timeout_datas[0] - this.monitor_input.timeout);
                for (let i = 1; i < this.timeout_datas.length; i++) {
                    const diff = Math.abs(this.timeout_datas[i] - this.monitor_input.timeout);
                    if (diff < closestDiff) {
                        closestDiff = diff;
                        closestIndex = i;
                    }
                }
                this.timeoutIndex = closestIndex;
                this.monitor_input.timeout = this.timeout_datas[closestIndex];
            } else {
                this.timeoutIndex = idx;
            }
        },
        incrementGraceTimeout() {
            if (this.graceTimeoutIndex < this.grace_timeout_datas.length - 1) {
                this.graceTimeoutIndex++;
                this.monitor_input.grace_interval = this.grace_timeout_datas[this.graceTimeoutIndex];
            }
        },
        decrementGraceTimeout() {
            if (this.graceTimeoutIndex > 0) {
                this.graceTimeoutIndex--;
                this.monitor_input.grace_interval = this.grace_timeout_datas[this.graceTimeoutIndex];
            }
        },
        updateGraceTimeoutIndex() {
            const idx = this.grace_timeout_datas.indexOf(this.monitor_input.grace_interval);
            if (idx === -1) {
                // Find closest value
                let closestIndex = 0;
                let closestDiff = Math.abs(this.grace_timeout_datas[0] - this.monitor_input.grace_interval);
                for (let i = 1; i < this.grace_timeout_datas.length; i++) {
                    const diff = Math.abs(this.grace_timeout_datas[i] - this.monitor_input.grace_interval);
                    if (diff < closestDiff) {
                        closestDiff = diff;
                        closestIndex = i;
                    }
                }
                this.graceTimeoutIndex = closestIndex;
                this.monitor_input.grace_interval = this.grace_timeout_datas[closestIndex];
            } else {
                this.graceTimeoutIndex = idx;
            }
        },
        toggleAccordion(section) {
            this.accordionStates[section] = !this.accordionStates[section];
        },
        toggleAlertDropdown() {
            this.showAlertDropdown = !this.showAlertDropdown;
            if(this.showAlertDropdown) {
                this.alertSearchQuery = '';
            }
        },
        isAlertSelected(alert) {
            return this.alertContacts.some(a => a.value === alert.value);
        },
        toggleAlert(alert) {
            const index = this.alertContacts.findIndex(a => a.value === alert.value);
            if(index > -1) {
                this.alertContacts.splice(index, 1);
            } else {
                this.alertContacts.push(alert);
            }
        },
        removeAlertContact(alert) {
            const index = this.alertContacts.findIndex(a => a.value === alert.value);
            if (index > -1) {
                this.alertContacts.splice(index, 1);
            }
        },
        closeDropdownOnClickOutside(event) {
            if (!event.target.closest('.alert-select')) {
                this.showAlertDropdown = false;
            }
            if (!event.target.closest('.maintenance-select')) {
                this.showMaintenanceDropdown = false;
            }
        },
        toggleMaintenanceDropdown() {
            this.showMaintenanceDropdown = !this.showMaintenanceDropdown;
            if(this.showMaintenanceDropdown) {
                this.maintenanceSearchQuery = '';
                this.$nextTick(() => {
                    this.positionMaintenanceDropdown();
                });
            }
        },
        positionMaintenanceDropdown() {
            const selectEl = document.querySelector('.maintenance-select');
            const dropdownEl = document.querySelector('.maintenance-dropdown');
            if (selectEl && dropdownEl) {
                const rect = selectEl.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                const dropdownHeight = 300; // max-height of dropdown
                
                // Calculate if dropdown should appear above or below
                const spaceBelow = viewportHeight - rect.bottom;
                const spaceAbove = rect.top;
                
                if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
                    // Show above
                    dropdownEl.style.bottom = (viewportHeight - rect.top + 4) + 'px';
                    dropdownEl.style.top = 'auto';
                } else {
                    // Show below
                    dropdownEl.style.top = (rect.bottom + 4) + 'px';
                    dropdownEl.style.bottom = 'auto';
                }
                
                dropdownEl.style.left = rect.left + 'px';
                dropdownEl.style.width = rect.width + 'px';
            }
        },
        isMaintenanceSelected(maintenance) {
            return this.selectedMaintenanceWindows.some(m => m.value === maintenance.value);
        },
        toggleMaintenance(maintenance) {
            const index = this.selectedMaintenanceWindows.findIndex(m => m.value === maintenance.value);
            if(index > -1) {
                this.selectedMaintenanceWindows.splice(index, 1);
            } else {
                this.selectedMaintenanceWindows.push(maintenance);
            }
        },
        removeMaintenanceWindow(maintenance) {
            const index = this.selectedMaintenanceWindows.findIndex(m => m.value === maintenance.value);
            if (index > -1) {
                this.selectedMaintenanceWindows.splice(index, 1);
            }
        },
        handleScroll() {
            if (this.showMaintenanceDropdown) {
                this.positionMaintenanceDropdown();
            }
        },
        handleResize() {
            if (this.showMaintenanceDropdown) {
                this.positionMaintenanceDropdown();
            }
        },
        checkIntervallimit(){
            if(this.not_premium && this.monitor_input.interval <5){
                this.monitor_input.interval = this.plan_details.minIntervalLimit
                var el = document.querySelector('#upgrade_btn');
                el.click()
            }
            this.sliderKey += 1;
        },
        checkCustomPostData(){
            if(this.monitor_input.http_method == 'POST' || this.monitor_input.http_method == 'PUT' || this.monitor_input.http_method == 'PATCH' || this.monitor_input.http_method == 'DELETE' || this.monitor_input.http_method == 'OPTIONS'){
                if(this.postContentType){
                    this.payload['postContentType'] = 2
                }
                else{
                    this.payload['postContentType'] = 1
                }
                if(this.post_data_type == 1){
                    let data = this.post_key_val_data.reduce((acc, { key, value }) => {
                                                acc[key] = value;
                                                return acc;
                                                }, {});
                    this.payload['postValue'] = JSON.stringify(data)
                }
                else{
                    this.payload['postValue'] = this.post_row_data
                }
                this.payload['postType'] = this.post_data_type
            }
        },
        updateAuth(val){
            this.monitor_input.auth_type = val
            this.authKey ++
        },
        MoveStatus(txt,value){
            switch(txt){
                case 'right':
                    this.monitor_input.down_status.push(value)
                    const index = this.monitor_input.up_status.indexOf(value);
                    if (index > -1) { // only splice array when item is found
                        this.monitor_input.up_status.splice(index, 1); // 2nd parameter means remove one item only
                    }
                    break;
                case 'left':
                    this.monitor_input.up_status.push(value)
                    const indx = this.monitor_input.down_status.indexOf(value);
                    if (indx > -1) { // only splice array when item is found
                            this.monitor_input.down_status.splice(indx, 1); // 2nd parameter means remove one item only
                    }
                    break;
            }
        },
        Clone(){
            this.custom_headers.push({value: '',key:''})
        },
        deltHeader(i){
            this.custom_headers.splice(i,1)
        },
        addTag (newTag) {
            const tag = {
                value: newTag,
                text: newTag
            }
            this.alerts.push(tag)
            this.alertContacts.push(tag)
        },
      async addMoreMonitor() {
            await this.onSubmit("addMore");
            // Only reset name and URL fields, keep the monitor type selected
            this.monitor_input.name = '';
            this.monitor_input.url = '';
            // Clear validation states for reset fields
            this.isNameEntered = false;
            this.isUrlEntered = false;
            this.isKeywordEntered = false;
            this.invalid_fname_message = '';
            this.invalid_url_message = '';
            this.invalid_keyword_message = '';
        },
        resetForm() {
            this.monitor_input = {
                name: '',
                type: null,
                url: '',
                interval: 1,
                timeout: 30,
                ssl_error: false,
                ssl_expiry_reminder: false,
                http_method: 'GET',
                auth_type: 1,
                up_status: [100, 103, 200, 201, 202, 203, 204, 205, 206, 207, 208, 226, 300, 301, 302, 303, 304, 305, 306, 307, 308],
                down_status: [400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 421, 422, 423, 424, 425, 426, 428, 429, 430, 431, 440, 449, 450, 451, 495, 496, 497, 499, 500, 501, 502, 503, 504, 505, 508, 509, 510, 511, 520, 521, 522, 523, 524, 525, 526, 527, 530, 598, 599],
                custom_header: [],
                keyword: '',
                case_sensitive: false,
                alertWhen: 1,
                port: null,
                custom_port: 1,
                devicetype: null,
                alertContacts: [],
                downAlertFreqType: 0,
                grace_interval: 30,
                proxyUrl: '',
                postContentType: 1,
                mwids: [],
                dayCount: 1,
                auth_username: '',
                auth_password: '',
            };
            this.alertContacts = [];
            this.selectedMaintenanceWindows = [];
            this.custom_headers = [{ value: '', key: '' }];
            this.post_key_val_data = [];
            this.post_row_data = '';
            this.isNameEntered = false;
            this.isUrlEntered = false;
            this.isKeywordEntered = false;
            this.isProxyUrlEntered = false;
            this.isPortSelected = false;
            this.isDeviceTypeSelected = false;
            this.isTypeSelected = false;
            this.interval_type = 'Minute';
            this.intervalIndex = 0;
            this.timeoutIndex = 29; // Default to 30 seconds
            this.graceTimeoutIndex = 0; // Default to 30 seconds
        }
    }
};
</script>

<style scoped>

.add-monitor-container {
    font-family: 'Poppins', sans-serif;
    width: 100%;
}

/* Allow dropdowns to overflow modal */
::v-deep .modal-body {
    overflow: visible !important;
}

::v-deep .modal-content {
    overflow: visible !important;
}

/* Global override for all inputs in this component */
.add-monitor-container input {
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
}

.add-monitor-container input:focus {
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
}

/* Form Layout */
.form-step-one,
.form-step-two {
    width: 100%;
}

/* Form Group */
.form-group {
    margin-bottom: 26px !important;
}

.form-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #3A3A3A;
    margin-bottom: 10px;
    display: block;
}

.required {
    color: #E70000;
}

/* Custom Select Wrapper */
.custom-select-wrapper {
    position: relative;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 0 12px;
    height: 48px;
    display: flex;
    align-items: center;
    gap: 10px;
}

/* Disabled select wrapper */
.custom-select-wrapper:has(.custom-form-select:disabled) {
    background: #F3F4F6;
}

.select-icon {
    width: 24px;
    height: 24px;
}

.custom-form-select {
    border: none !important;
    background: transparent !important;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #3A3A3A;
    padding: 0 0 0 10px !important;
    height: auto;
    flex: 1;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.custom-form-select:focus {
    box-shadow: none !important;
    outline: none !important;
    background: transparent !important;
    border: none !important;
}

.custom-form-select option {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
}

.dropdown-arrow {
    position: absolute;
    right: 20px;
    pointer-events: none;
}

/* Custom Input Wrapper */
.custom-input-wrapper {
    background: #FFFFFF !important;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 0 12px;
    height: 48px;
    display: flex;
    align-items: center;
    position: relative;
}

/* Disabled input wrapper */
.custom-input-wrapper:has(.custom-form-input:disabled) {
    background: #F3F4F6;
}

.custom-input-wrapper.has-validation {
    padding-right: 40px;
}

/* Validation Icon */
.validation-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.validation-icon svg {
    width: 20px;
    height: 20px;
}

.custom-form-input {
    border: none !important;
    background: transparent !important;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #3A3A3A;
    padding: 0 !important;
    height: auto;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.custom-form-input:focus {
    box-shadow: none !important;
    outline: none !important;
    background: transparent !important;
    border: none !important;
}

.custom-form-input::placeholder {
    color: #3A3A3A;
    opacity: 0.5;
}

/* Form Actions */
.form-actions {
    display: flex;
    justify-content: center;
    padding-top: 0;
    width: 100%;
}

.form-actions-dual {
    gap: 12px;
}

.form-actions:not(.form-actions-dual) .btn-primary-custom {
    width: 100%;
}

.form-actions-dual .btn-primary-custom,
.form-actions-dual .btn-secondary-custom {
    width: calc(50% - 6px);
}

/* Buttons */
.btn-primary-custom {
    background: #2FB234;
    border: none;
    border-radius: 12px;
    padding: 12px 40px;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 48px;
}

.btn-primary-custom:hover:not(:disabled) {
    background: #28A02D;
    transform: translateY(-1px);
}

.btn-primary-custom.disabled,
.btn-primary-custom:disabled {
    background: #7D8699;
    cursor: not-allowed;
    opacity: 1;
    transform: none;
}

.btn-secondary-custom {
    background: #7D8699;
    border: none;
    border-radius: 12px;
    padding: 12px 40px;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 48px;
}

.btn-secondary-custom:hover:not(:disabled) {
    background: #6B7280;
    transform: translateY(-1px);
}

.btn-secondary-custom.disabled,
.btn-secondary-custom:disabled {
    background: #7D8699;
    cursor: not-allowed;
    opacity: 1;
    transform: none;
}

/* Multi Select Buttons */
.mul-select-btn-active,
.mul-select-btn-inactive {
    padding: 8px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    margin-right: 10px;
    display: inline-block;
}

.mul-select-btn-active {
    background-color: #3B82F6;
    color: #FFFFFF;
}

.mul-select-btn-inactive {
    background-color: #F3F4F6;
    color: #6B7280;
}

.mul-select-btn-inactive:hover {
    background-color: #E5E7EB;
}

/* Alert When Buttons */
.alert-when-buttons {
    display: flex;
    gap: 12px;
}

/* HTTP Method Buttons */
.http-method-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

/* Post Data Section */
.post-data-section {
    padding: 20px;
    background-color: #F9FAFB;
    border-radius: 12px;
    margin-top: 20px;
}

/* Post Key Value Container - Same as Custom Headers */
.post-key-value-container {
    margin-top: 20px;
}

/* Post Raw Data Container */
.post-raw-data-container {
    margin-top: 20px;
}

/* Raw Data Wrapper */
.raw-data-wrapper {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 20px;
}

/* Raw Data Input */
.raw-data-input {
    width: 100%;
    border: none;
    background: #FFFFFF !important;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #3A3A3A;
    resize: vertical;
    min-height: 100px;
}

.raw-data-input:focus {
    outline: none;
    border: none;
    box-shadow: none;
    background: #FFFFFF !important;
}

.raw-data-input::placeholder {
    color: #3A3A3A;
    opacity: 0.3;
}

/* Interval Display */
.interval-display {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #6B7280;
    margin-top: 8px;
}

/* Custom Multiselect */
.custom-multiselect >>> .multiselect__tags {
    background-color: #FFFFFF !important;
    border: 1px solid #D2E3FB;
    border-radius: 12px !important;
    min-height: 48px;
    padding: 8px 40px 0px 12px;
    font-family: 'Poppins', sans-serif !important;
    font-size: 16px !important;
    font-weight: 500 !important;
}

.custom-multiselect >>> .multiselect__placeholder,
.custom-multiselect >>> .multiselect__single,
.custom-multiselect >>> .multiselect__option,
.custom-multiselect >>> .multiselect__content,
.custom-multiselect >>> .multiselect__tags-wrap {
    font-family: 'Poppins', sans-serif !important;
    font-size: 16px !important;
    font-weight: 500 !important;
}

.custom-multiselect >>> .multiselect__tag {
    font-family: 'Poppins', sans-serif !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    border-radius: 8px !important;
    padding: 4px 22px 4px 12px !important;
    margin: 2px 4px 2px 0 !important;
    background: #F3F4F6 !important;
    color: #3A3A3A !important;
    display: inline-flex;
    align-items: center;
}

.custom-multiselect >>> .multiselect__tag-icon {
    font-size: 16px !important;
    margin-left: 26px;
}

/* Invalid Feedback - Hidden since we show icons inside fields */
.invalid-feedback {
    display: none;
}

/* Info Text */
.info_txt {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #6B7280;
}

.info-text {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #6B7280;
}

/* Link Text */
.link_txt {
    color: #3B82F6;
    cursor: pointer;
    text-decoration: none;
    font-size: 14px;
}

.link_txt:hover {
    text-decoration: underline;
}

/* Cursor Pointer */
.cursor_pointer {
    cursor: pointer;
}

/* Text Colors */
.text-info {
    color: #3B82F6;
}

.text-danger {
    color: #EF4444;
}

.text-success {
    color: #10B981;
}

/* Font Sizes */
.f-20 {
    font-size: 20px;
}

.drag-drop-vue div:nth-child(odd){
    background-color: #bcffbb3d;
    border: none;
    border-radius: 8px;
    padding:5px;
}
.drag-drop-vue div {
    background-color: #ffe0e08a;
    border: none;
    border-radius: 8px;
    padding:5px;
    float: left;
}
.drag-btn-up{
    text-align: center !important;
    background: green !important;
    font-weight: 700;
    max-width: 60px;
    float: right;
    border-radius: 8px;
    margin: 5px;

}
.drag-btn-down{
    text-align: center !important;
    background: rgb(164, 13, 13) !important;
    color: white !important;
    font-weight: 700;
    max-width: 60px;
    float: right;
    border-radius: 8px;
    margin: 5px;

}

/* Badge */
.badge-gray {
    background-color: #E5E7EB;
    color: #6B7280;
    font-size: 12px;
}

/* Authentication Settings Styles */
.auth-inputs-row {
    display: flex;
    gap: 25px;
    margin-bottom: 30px;
}

.auth-input-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.auth-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #3A3A3A;
    margin-bottom: 0;
}

.auth-input-wrapper {
    position: relative;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 0 20px;
}

.auth-input-wrapper.is-invalid {
    border-color: #dc3545;
}

.auth-input {
    background: transparent;
    border: none;
    padding: 0;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #3A3A3A;
    height: 48px;
    width: 100%;
}

.auth-input:focus {
    border: none;
    box-shadow: none;
    outline: none;
}

.auth-input::placeholder {
    color: #3A3A3A;
    opacity: 0.3;
}

.auth-type-dropdown {
    position: relative;
}

.auth-select {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 20px;
    padding-right: 50px;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #3A3A3A;
    height: 48px;
    background-image: url("data:image/svg+xml,%3Csvg width='10' height='5' viewBox='0 0 10 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0L5 5L10 0' stroke='%233A3A3A' stroke-width='2.3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 20px center;
    background-size: 10px 5px;
    appearance: none;
}

.auth-select:focus {
    border-color: #D2E3FB;
    box-shadow: none;
}

.auth-select.placeholder-selected {
    color: #3A3A3A;
    opacity: 0.3;
}

.auth-password-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.password-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 0 20px;
}

.password-icon {
    margin-right: 10px;
    flex-shrink: 0;
}

.auth-input.with-icons {
    border: none;
    padding: 0;
    background: transparent;
    flex: 1;
}

.password-toggle {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.password-toggle:focus {
    outline: none;
}

/* Custom Headers Styles */
.header-instruction {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #3A3A3A;
    margin-top: -5px;
    margin-bottom: 20px;
}

.header-key-text,
.header-value-text {
    color: #0062CC;
    font-weight: 500;
}

.add-header-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #D2E3FB;
    border-radius: 12px;
    padding: 10px 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #3A3A3A;
}

.add-header-button:hover {
    background: #C0D4F5;
}

.custom-headers-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.header-row {
    display: flex;
    align-items: flex-end;
    gap: 25px;
}

.header-inputs {
    display: flex;
    gap: 25px;
    flex: 1;
}

.header-input-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.header-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #3A3A3A;
    margin-bottom: 0;
}

.header-input-wrapper {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 0 20px;
}

.header-input {
    background: transparent;
    border: none;
    padding: 0;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #3A3A3A;
    height: 48px;
    width: 100%;
}

.header-input:focus {
    border: none;
    box-shadow: none;
    outline: none;
}

.header-input::placeholder {
    color: #3A3A3A;
    opacity: 0.3;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 25px;
}

.header-delete-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #FDE6E6;
    border: none;
    border-radius: 12px;
    padding: 10px 20px;
    height: 48px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #F20707;
}

.header-delete-btn:hover {
    background: #FCD4D4;
}

.header-add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #D2E3FB;
    border: none;
    border-radius: 12px;
    padding: 10px 20px;
    height: 48px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.header-add-btn:hover {
    background: #C0D4F5;
}

/* Custom Proxy Styles */
.proxy-input-wrapper {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 0 20px;
    height: 48px;
    display: flex;
    align-items: center;
    position: relative;
}
.proxy-input-wrapper.has-validation {
    padding-right: 48px;
}

.proxy-input {
    background: transparent;
    border: none;
    padding: 0;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #3A3A3A;
    height: 100%;
    width: 100%;
}

.proxy-input:focus {
    border: none;
    box-shadow: none;
    outline: none;
}

.proxy-input::placeholder {
    color: #3A3A3A;
    opacity: 0.3;
}

/* Maintenance Windows Styles */
.maintenance-window-wrapper {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    margin-top: 30px;
}

.maintenance-window-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
}

.maintenance-window-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #3A3A3A;
}

.maintenance-dropdown-inner {
    padding: 0 20px 20px 20px;
    position: relative;
}

/* Disabled Fields Cursor */
.form-input:disabled,
.form-select:disabled,
.interval-input:disabled,
.timeout-input:disabled,
.grace-timeout-input:disabled,
.b-form-input:disabled,
.b-form-select:disabled,
.custom-multiselect.is-disabled,
.multiselect--disabled,
input[disabled],
select[disabled],
.form-control:disabled,
.custom-select:disabled {
    cursor: not-allowed !important;
}

/* Disabled state for custom components */
.form-input:disabled::placeholder,
.interval-input:disabled::placeholder,
.timeout-input:disabled::placeholder,
.grace-timeout-input:disabled::placeholder {
    cursor: not-allowed !important;
}

/* Force white background on all input fields */
.b-form-input,
.form-control,
.custom-form-input,
input[type="text"],
input[type="number"],
input[type="url"],
input[type="email"],
input[type="password"],
input.form-control,
.custom-input-wrapper input,
.custom-input-wrapper .b-form-input {
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
}

/* Ensure focus states maintain white background */
.b-form-input:focus,
.form-control:focus,
.custom-form-input:focus,
input[type="text"]:focus,
input[type="number"]:focus,
input[type="url"]:focus,
input[type="email"]:focus,
input[type="password"]:focus,
input.form-control:focus,
.custom-input-wrapper input:focus,
.custom-input-wrapper .b-form-input:focus {
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
}

/* Override Bootstrap default styles */
.form-control:not(:disabled):not([readonly]) {
    background-color: #FFFFFF !important;
}

/* Remove webkit autofill background */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    box-shadow: 0 0 0 30px white inset !important;
    background-color: #FFFFFF !important;
}

/* Ensure all b-form-input elements have white background */
::v-deep .b-form-input {
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
}

::v-deep input.form-control {
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
}

/* Disabled multiselect */
.multiselect--disabled .multiselect__tags,
.multiselect--disabled .multiselect__single,
.multiselect--disabled .multiselect__select {
    cursor: not-allowed !important;
    background-color: #f8f9fa !important;
}

/* Disabled buttons */
.interval-button:disabled,
.timeout-button:disabled,
.grace-timeout-button:disabled,
button:disabled {
    cursor: not-allowed !important;
    opacity: 0.6;
}

/* Disabled checkboxes and radio buttons */
input[type="checkbox"]:disabled,
input[type="radio"]:disabled,
input[type="checkbox"]:disabled + label,
input[type="radio"]:disabled + label {
    cursor: not-allowed !important;
}

/* Monitor type selector when editing */
.b-form-select[name="type"]:disabled {
    cursor: not-allowed !important;
    background-color: #f8f9fa !important;
}

/* Port selector disabled state */
.b-form-select option:disabled {
    cursor: not-allowed !important;
}

/* Alert frequency disabled options */
.b-form-select-option[disabled] {
    cursor: not-allowed !important;
}

/* Custom port input when disabled */
.form-input[type="number"]:disabled {
    cursor: not-allowed !important;
    background-color: #f8f9fa !important;
}

/* Increment/decrement buttons when disabled */
.interval-button[disabled],
.timeout-button[disabled],
.grace-timeout-button[disabled] {
    cursor: not-allowed !important;
    background-color: #e9ecef !important;
    color: #6c757d !important;
}

/* SSL checkbox containers when URL doesn't start with https */
.ssl-container input[type="checkbox"]:disabled + label {
    cursor: not-allowed !important;
    opacity: 0.6;
}

/* Interval Container */
.interval-container {
    display: flex;
    gap: 16px;
    align-items: stretch;
}

/* New Interval Container Design */
.new-interval-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 8px 20px;
    gap: 30px;
    height: 48px;
}

.interval-controls {
    display: flex;
    align-items: center;
    gap: 20px;
}

.interval-control-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
}

.interval-control-btn span {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 1;
    color: #3A3A3A;
}

.interval-control-btn:hover:not(:disabled) {
    background: #F3F4F6;
}

.interval-control-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.interval-value {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 1;
    color: #3A3A3A;
    min-width: 30px;
    text-align: center;
}

.interval-unit-text {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 1;
    color: #3A3A3A;
    margin-right: auto;
}

/* Alert Dropdown Styles */
.alert-select {
    cursor: pointer;
}

.select-placeholder {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #3A3A3A;
    opacity: 0.6;
    flex: 1;
}

.alert-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    z-index: 1000;
    max-height: 300px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.alert-search {
    padding: 12px;
    border-bottom: 1px solid #E5E7EB;
}

.alert-search-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #D2E3FB;
    border-radius: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    outline: none;
}

.alert-search-input:focus {
    border-color: #3B82F6;
}

.alert-options {
    overflow-y: auto;
    max-height: 240px;
}

.alert-option {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    gap: 12px;
}

.alert-option:hover {
    background-color: #F9FAFB;
}

.alert-option.selected {
    background-color: #F3F4F6;
}

.alert-checkbox {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

/* Selected Alerts Section */
.selected-alerts-section {
    margin-top: 16px;
}

.selected-alerts-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.alert-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 12px;
    background: rgba(41, 51, 64, 0.15);
    border-radius: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #3A3A3A;
    position: relative;
}

.alert-tag-dot {
    width: 6px;
    height: 6px;
    background-color: #6B7280;
    border-radius: 50%;
}

.tag-remove {
    cursor: pointer;
    transition: transform 0.2s ease;
}

.tag-remove:hover {
    transform: scale(1.1);
}

/* Maintenance Dropdown Styles - Matching Alert Dropdown */
.maintenance-select {
    cursor: pointer;
}

.maintenance-dropdown {
    position: fixed;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    z-index: 9999;
    max-height: 300px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-width: 300px;
}

.maintenance-search {
    padding: 12px;
    border-bottom: 1px solid #E5E7EB;
}

.maintenance-search-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #D2E3FB;
    border-radius: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    outline: none;
}

.maintenance-search-input:focus {
    border-color: #3B82F6;
}

.maintenance-options {
    overflow-y: auto;
    max-height: 240px;
}

.maintenance-option {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    gap: 12px;
}

.maintenance-option:hover {
    background-color: #F9FAFB;
}

.maintenance-option.selected {
    background-color: #F3F4F6;
}

.maintenance-checkbox {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.badge-maintenance {
    margin-left: auto;
    background: #E5E7EB;
    color: #6B7280;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

/* Selected Maintenance Section */
.selected-maintenance-section {
    margin-top: 16px;
}

.selected-maintenance-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.maintenance-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 12px;
    background: rgba(41, 51, 64, 0.15);
    border-radius: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #3A3A3A;
    position: relative;
}

.maintenance-tag-dot {
    width: 6px;
    height: 6px;
    background-color: #6B7280;
    border-radius: 50%;
}

.interval-input-wrapper,
.interval-unit-wrapper {
    flex: 1 1 0;
    width: 50%;
    min-width: 0;
    box-sizing: border-box;
}

.interval-input-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 6px;
    height: 48px;
    gap: 8px;
}

.interval-unit-wrapper {
    display: flex;
    align-items: center;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding-left: 20px;
    padding-right: 10px;
    height: 48px;
    position: relative;
}

.interval-btn {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #3A3A3A;
    transition: all 0.2s ease;
    padding: 0;
    flex-shrink: 0;
}

.interval-btn:hover:not(:disabled) {
    background: #F3F4F6;
}

.interval-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.interval-input {
    border: none;
    background: #FFFFFF;
    text-align: center;
    width: auto;
    min-width: 30px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 0.915em;
    color: #3A3A3A;
    outline: none;
}

/* Remove spinner arrows */
.interval-input::-webkit-inner-spin-button,
.interval-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}

.interval-input[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
}

.interval-unit-select {
    width: 100%;
    height: 48px !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
}

/* Vue Slider Custom Styles */
.vue-slider-rail {
    background-color: #E5E7EB !important;
}

.vue-slider-process {
    background-color: #3B82F6 !important;
}

.vue-slider-dot-handle {
    background-color: #3B82F6 !important;
    border: 2px solid #FFFFFF !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

/* Advanced Settings Styles */
.advanced-settings-section {
    margin-top: 30px;
}

.advanced-settings-container {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    padding: 20px;
}

.advanced-settings-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
}

.advanced-settings-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 0.915em;
    color: #3A3A3A;
}

.settings-divider {
    border: none;
    border-top: 1px solid #D2E3FB;
    margin: 20px 0;
}

/* Toggle Switch */
.toggle-switch {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 22px;
    cursor: pointer;
}

.toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 22px;
}

.toggle-slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
    box-shadow: 0px 2px 0.7px 0px rgba(0, 0, 0, 0.06),
                0px 2px 5.7px 0px rgba(0, 0, 0, 0.15),
                0px 0px 0px 0.7px rgba(0, 0, 0, 0.04);
}

.toggle-switch input:checked + .toggle-slider {
    background-color: #34C759;
}

.toggle-switch input:checked + .toggle-slider:before {
    transform: translateX(14px);
}

/* Accordion Styles */
.advanced-settings-content {
    margin-top: 20px;
}

.accordion-item {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    margin-bottom: 12px;
    overflow: hidden;
}

.accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
}

.accordion-header:hover {
    background-color: #F9FAFB;
}

.accordion-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 0.915em;
    color: #3A3A3A;
}

.accordion-arrow {
    transition: transform 0.3s ease;
    flex-shrink: 0;
}

.accordion-arrow.rotated {
    transform: rotate(180deg);
}

.accordion-content {
    padding: 0 20px 20px 20px;
    animation: slideDown 0.3s ease;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* SSL Checkbox Styles */
.ssl-options-container {
    display: flex;
    gap: 55px;
    align-items: flex-start;
}

.ssl-option {
    flex: 1;
    display: flex;
    align-items: flex-start;
}

.ssl-option .custom-checkbox {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    margin: 0;
    position: relative;
}

.ssl-checkbox-wrapper {
    margin-bottom: 0;
}

.custom-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    padding-left: 32px;
    user-select: none;
    min-height: 24px;
}

.custom-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkbox-checkmark {
    position: absolute;
    top: 2px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #FFFFFF;
    border: 1.25px solid #D2E3FB;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.custom-checkbox:hover input ~ .checkbox-checkmark {
    border-color: #9CA3AF;
}

.custom-checkbox input:checked ~ .checkbox-checkmark {
    background-color: #0062CC;
    border-color: #0062CC;
}

.checkbox-checkmark:after {
    content: "";
    position: absolute;
    display: none;
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.custom-checkbox input:checked ~ .checkbox-checkmark:after {
    display: block;
}

.checkbox-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #3A3A3A;
    line-height: 24px;
}

.ssl-hint {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #6B7280;
    margin: 8px 0 0 32px;
    line-height: 1.4;
}

/* Responsive */
@media screen and (max-width: 768px) {
    .form-step-two .col-md-6 {
        padding-right: 15px;
        padding-left: 15px;
        margin-bottom: 20px;
    }
    
    .btn-primary-custom,
    .btn-secondary-custom {
        margin-bottom: 10px;
    }

    .btn-secondary-custom {
        margin-left: 0 !important;
    }

    .http-method-buttons,
    .alert-when-buttons {
        flex-wrap: wrap;
    }

    .interval-container {
        flex-direction: column;
    }
    
    .interval-input-wrapper,
    .interval-unit-wrapper {
        width: 100%;
    }
    
    /* New interval container responsive */
    .new-interval-container {
        padding: 8px 15px;
        height: 48px;
        gap: 15px;
    }
    
    .interval-controls {
        gap: 15px;
    }
    
    .interval-control-btn {
        width: 28px;
        height: 28px;
    }
    
    .interval-control-btn span,
    .interval-value,
    .interval-unit-text {
        font-size: 14px;
    }
}

/* Keyword Monitor Styles */
.form-label-info {
    font-weight: 400;
    font-size: 14px;
    color: #7B889C;
}

.alert-when-container {
    display: flex;
    gap: 55px;
    align-items: center;
}

.alert-when-option {
    flex: 1;
    display: flex;
    align-items: center;
}

.alert-when-option .custom-checkbox {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    margin: 0;
    position: relative;
}

.alert-when-option .custom-checkbox input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.alert-when-option .checkbox-checkmark {
    height: 20px;
    width: 20px;
    background-color: #FFFFFF;
    border: 1.25px solid #D2E3FB;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.alert-when-option .custom-checkbox input:checked ~ .checkbox-checkmark {
    background-color: #0062CC;
    border-color: #0062CC;
}

.alert-when-option .checkbox-checkmark:after {
    content: "";
    position: absolute;
    display: none;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-left: 1px;
    margin-bottom: 1px;
}

.alert-when-option .custom-checkbox input:checked ~ .checkbox-checkmark:after {
    display: block;
}

.alert-when-option .checkbox-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    color: #3A3A3A;
    margin: 0;
    padding: 0;
}

.keyword-case-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 17px 20px;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    height: 56px;
}

.case-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 14.64px;
    color: #3A3A3A;
}

@media (max-width: 768px) {
    .alert-when-container {
        flex-direction: column;
        gap: 10px;
    }
    
    .alert-when-option {
        width: 100%;
    }
    
    .ssl-options-container {
        flex-direction: column;
        gap: 10px;
    }
    
    .ssl-option {
        width: 100%;
    }
}
</style>